<!--
 * @Author: shp
 * @Date: 2023-10-09 09:59:24
 * @LastEditTime: 2024-11-21 10:04:33
 * @FilePath: /vueSaas/saas/src/components/adver/Bliadver.vue
 * @Description: 
-->
<template>
    <div class="k-page-content adver">
      <el-tabs v-model="activeName" class="box-eltab">
        <el-tab-pane label="批量单元" name="adgroup">
            <div class="top-filter">
              <el-form
                style="margin-bottom: 20px;"
                :inline="true"
                :size="size"
                class="demo-form-inline">
                <el-form-item>
                  <el-input v-model="adgroupDataTable.name" clearable placeholder="请输入单元名称"></el-input>
                </el-form-item>
                <el-form-item>
                  <el-date-picker
                    clearable
                    align="center"
                    :size="size"
                    v-model="adgroupDataTable.dateTime"
                    type="daterange"
                    value-format="yyyy-MM-dd"
                    range-separator="至"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期"
                  ></el-date-picker>
                </el-form-item>
                <el-form-item>
                  <el-button type="primary" @click="handleCurrentChangeAdgroup(1)">搜索</el-button>
                </el-form-item>
              </el-form>
            </div>
            <div>
              <div class="ks_toolbar" style="margin-bottom:10px;">
                <p class="title">
                  <span>单元记录</span>
                  <span style="margin-left:30px">
                    <el-link
                      style="font-size: 10px;"
                      type="primary"
                      :underline="false"
                      @click="changeMedia"
                      v-if="$parent.mediaOptions.length > 1"
                    >切换媒体</el-link>
                  </span>
                </p>
                <p>
                  <el-button type="primary" :size="size" @click="createTemplate">批量单元</el-button>
                </p>
              </div>
              <el-table
                v-loading="loading"
                border
                :data="adgroupDataTable.data"
                :header-cell-style="{background:'#f5f7fa'}"
                style="width: 100%"
              >
                <el-table-column property="id" fixed label="序号" width="80"></el-table-column>
                <el-table-column property="campaign_name" fixed min-width="200" label="计划信息">
                  <template slot-scope="scope">
                    <p>标识：{{ scope.row.campaign_id }}</p>
                    <p>名称：{{ scope.row.campaign_name }}</p>
                  </template>
                </el-table-column>
                <el-table-column property="unit_name" fixed min-width="200" label="单元信息">
                  <template slot-scope="scope">
                    <p>标识：{{ scope.row.adgroup_id }}</p>
                    <p>名称：{{ scope.row.unit_name }}</p>
                  </template>
                </el-table-column>
                <el-table-column property="status_text" min-width="100" label="创建信息">
                  <template slot-scope="scope">
                    <el-popover
                      v-if="scope.row.status_text"
                      placement="top"
                      title="信息"
                      width="300"
                      trigger="hover"
                    >
                      <p>计划：{{ scope.row.campaign_status_text }}</p>
                      <p>单元：{{ scope.row.status_text }}</p>
                      <el-button v-if="scope.row.status_text" slot="reference" type="text">查看</el-button>
                    </el-popover>
                  </template>
                </el-table-column>
                <el-table-column min-width="180" label="状态">
                  <template slot-scope="scope">
                    <p>计划状态：
                      <span v-if="scope.row.campaign_line_status == 0">暂无</span>
                      <span v-if="scope.row.campaign_line_status == 1">有效</span>
                      <span v-if="scope.row.campaign_line_status == 2">已暂停</span>
                      <span v-if="scope.row.campaign_line_status == 3">已结束</span>
                      <span v-if="scope.row.campaign_line_status == 4">已删除</span>
                      <span v-if="scope.row.campaign_line_status == 5">预算超限</span>
                      <el-button
                        style="margin-left:5px"
                        type="text"
                        v-if="scope.row.campaign_id"
                        @click="refresh('campaign',scope.row.campaign_auto_id)"
                      >刷新</el-button>
                    </p>
                    <p>单元状态：
                      <span v-if="scope.row.line_status == 0">暂无</span>
                      <span v-if="scope.row.line_status == 1">有效</span>
                      <span v-if="scope.row.line_status == 2">已暂停</span>
                      <span v-if="scope.row.line_status == 3">已完成</span>
                      <span v-if="scope.row.line_status == 4">已删除</span>
                      <span v-if="scope.row.line_status == 5">深度审核中</span>
                      <span v-if="scope.row.line_status == 6">审核拒绝</span>
                      <span v-if="scope.row.line_status == 7">修改待下线</span>
                      <span v-if="scope.row.line_status == 8">已下线</span>
                      <span v-if="scope.row.line_status == 9">落地页待审核</span>
                      <el-button
                        style="margin-left:5px"
                        type="text"
                        v-if="scope.row.adgroup_id != 0"
                        @click="refresh('adgroup',scope.row.id)"
                      >刷新</el-button>
                    </p>
                  </template>
                </el-table-column>
                <el-table-column min-width="120" label="推广目的">
                  <template slot-scope="scope">
                    <span v-if="scope.row.promotion_purpose_type == 2">销售线索收集</span>
                    <span v-if="scope.row.promotion_purpose_type == 4">应用推广</span>
                    <span v-if="scope.row.promotion_purpose_type == 6">安卓游戏</span>
                    <span v-if="scope.row.promotion_purpose_type == 8">直播推广</span>
                    <span v-if="scope.row.promotion_purpose_type == 9">店铺推广</span>
                    <span v-if="scope.row.promotion_purpose_type == 15">品牌传播</span>
                  </template>
                </el-table-column>
                <el-table-column min-width="80" label="预算类型">
                  <template slot-scope="scope">
                    <span v-if="scope.row.budget_limit_type == 1">指定预算</span>
                    <span v-if="scope.row.budget_limit_type == 2">不限预算</span>
                  </template>
                </el-table-column>
                <el-table-column property="budget" min-width="130" label="计划预算金额/元">
                  <template slot-scope="scope">
                    <el-link
                      v-if="scope.row.campaign_id && scope.row.campaign_id != 0"
                      type="primary"
                      @click="editBudget('campaignDataTable',[{'id':scope.row.campaign_auto_id,'ad_id':scope.row.campaign_id,'advertiser_id':scope.row.aid}])"
                    >{{scope.row.campaign_budget/100}}</el-link>
                    <span v-else>{{scope.row.budget/100}}</span>
                  </template>
                </el-table-column>
                <el-table-column min-width="180" label="投放日期">
                  <template slot-scope="scope">
                    <p>开始：{{ scope.row.begin_date }}</p>
                    <p>结束：{{ scope.row.end_date }}</p>
                  </template>
                </el-table-column>
                <el-table-column min-width="80" label="投放时段">
                  <template slot-scope="scope">
                    <el-popover
                      placement="top"
                      trigger="hover"
                      v-if="scope.row.other_info.launch_time.length > 0"
                    >
                      <p v-for="(item,index) in scope.row.other_info.launch_time" :key="index">
                        <template v-if="index == 0">星期一：{{returnInitTime(item)}}</template>
                        <template v-if="index == 1">星期二：{{returnInitTime(item)}}</template>
                        <template v-if="index == 2">星期三：{{returnInitTime(item)}}</template>
                        <template v-if="index == 3">星期四：{{returnInitTime(item)}}</template>
                        <template v-if="index == 4">星期五：{{returnInitTime(item)}}</template>
                        <template v-if="index == 5">星期六：{{returnInitTime(item)}}</template>
                        <template v-if="index == 6">星期日：{{returnInitTime(item)}}</template>
                      </p>
                      <el-button slot="reference" type="text">时段</el-button>
                    </el-popover>
                  </template>
                </el-table-column>
                <el-table-column min-width="80" property="frequency_unit" label="限制周期"></el-table-column>
                <el-table-column min-width="80" property="sales_type" label="售卖类型"></el-table-column>
                <el-table-column property="budget" min-width="130" label="单元预算金额/元">
                  <template slot-scope="scope">
                    <el-link
                      v-if="scope.row.adgroup_id && scope.row.adgroup_id != 0"
                      type="primary"
                      @click="editBudget('adgroupDataTable',[{'id':scope.row.id,'ad_id':scope.row.adgroup_id,'advertiser_id':scope.row.aid}])"
                    >{{scope.row.budget/100}}</el-link>
                    <span v-else>{{scope.row.budget/100}}</span>
                  </template>
                </el-table-column>
                <el-table-column min-width="180" label="账户信息">
                  <template slot-scope="scope">
                    <el-tooltip placement="top" effect="light">
                      <div slot="content">
                        标识：{{scope.row.account_id}}
                        <br />
                        名称：{{scope.row.aid_name}}
                      </div>
                      <p>标识：{{ scope.row.account_id }}</p>
                    </el-tooltip>
                    <p
                      style="width: 150px;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;"
                    >名称：{{ scope.row.aid_name }}</p>
                  </template>
                </el-table-column>
                <el-table-column property="admin_id" min-width="80" label="创建人"></el-table-column>
                <el-table-column property="create_time" min-width="180" label="创建日期"></el-table-column>
                <el-table-column min-width="180" label="操作" fixed='right'>
                  <template slot-scope="scope" >
                    <!-- <el-button type="text" @click="editAdgroup(scope.row.id)">修改</el-button> -->
                    <template v-if="scope.row.line_status == 2">
                      <el-popconfirm
                        title="确定要启用当条记录吗？"
                        @confirm="editStatus('adgroupDataTable', '1',[{'id':scope.row.id,'ad_id':scope.row.adgroup_id,'advertiser_id':scope.row.aid}])"
                      >
                        <el-button slot="reference" type="text">启用</el-button>
                      </el-popconfirm>
                    </template>
                    <template
                      v-if="scope.row.line_status == 1 || scope.row.line_status == 5 || scope.row.line_status == 6 || scope.row.line_status == 7"
                    >
                      <el-popconfirm
                        title="确定要暂停当条记录吗？"
                        @confirm="editStatus('adgroupDataTable', '2',[{'id':scope.row.id,'ad_id':scope.row.adgroup_id,'advertiser_id':scope.row.aid}])"
                      >
                        <el-button slot="reference" type="text">暂停</el-button>
                      </el-popconfirm>
                    </template>
                    <template
                      v-if="scope.row.adgroup_id && scope.row.adgroup_id != 0 && scope.row.line_status != 4"
                    >
                      <el-popconfirm
                        title="确定要删除当条记录吗？"
                        @confirm="editStatus('adgroupDataTable', '3',[{'id':scope.row.id,'ad_id':scope.row.adgroup_id,'advertiser_id':scope.row.aid}])"
                      >
                        <el-button slot="reference" type="text">删除</el-button>
                      </el-popconfirm>
                    </template>
                  </template>
                </el-table-column>
              </el-table>
              <el-pagination
                background
                @current-change="handleCurrentChangeAdgroup"
                :current-page="adgroupDataTable.page | number"
                :page-sizes="[10, 20, 30, 40]"
                :page-size="adgroupDataTable.pagesize | number"
                layout="total, prev, pager, next, jumper"
                :total="adgroupDataTable.total | number"
              ></el-pagination>
            </div>
        </el-tab-pane>
        <el-tab-pane label="批量创意" name="adcreative">
          <div class="top-filter">
            <el-form
              style="margin-bottom: 20px;"
              :inline="true"
              :size="size"
              class="demo-form-inline"
            >
              <el-form-item>
                <el-input v-model="adcreativeDataTable.name" placeholder="请输入创意名称"></el-input>
              </el-form-item>
              <el-form-item>
                <el-date-picker
                  align="center"
                  :size="size"
                  v-model="adcreativeDataTable.dateTime"
                  type="daterange"
                  value-format="yyyy-MM-dd"
                  range-separator="至"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                ></el-date-picker>
              </el-form-item>
              <el-form-item>
                <el-button type="primary" @click="handleCurrentChangeAdcreative(1)">搜索</el-button>
              </el-form-item>
            </el-form>
          </div>
          <div class="ks_content">
            <div class="ks_toolbar" style="margin-bottom:10px;">
              <p class="title">
                <span>创意记录</span>
                <span style="margin-left:30px">
                  <el-link
                    style="font-size: 10px;"
                    type="primary"
                    :underline="false"
                    @click="changeMedia"
                    v-if="$parent.mediaOptions.length > 1"
                  >切换媒体</el-link>
                </span>
              </p>
              <p>
                <el-button type="primary" :size="size" @click="openAdcreativeDrawer">创意创建</el-button>
              </p>
            </div>
            <el-table
              border
              :data="adcreativeDataTable.data"
              :header-cell-style="{background:'#f5f7fa'}"
              style="width: 100%"
              v-loading="loading"
            >
              <el-table-column property="id" fixed label="序号" width="80"></el-table-column>
              <el-table-column fixed label="稿件" width="140">
                <template slot-scope="scope">
                  <div v-if="scope.row.model == '程序化创意'" class="grid">
                    <div class="kImgBoxS">
                        <template  v-if="'bili_video_media_list' in scope.row.other_info.media_groups[0]" >
                          <div
                          v-for="(item,index) in scope.row.other_info.media_groups[0].bili_video_media_list"
                          v-if="index <= 3"
                          class="img"
                          :style="{'background-image':'url('+returnVideoUrl(item.video_cover.url)+')'}"
                          ></div>
                        </template>
                        <template v-if="'mono_media_list' in scope.row.other_info.media_groups[0]">
                          <div
                            v-for="(item,index) in scope.row.other_info.media_groups[0].mono_media_list"
                            v-if="index <= 3"
                            class="img"
                            :style="{'background-image':'url('+returnVideoUrl(item.url)+')'}"
                          ></div>
                        </template>  
                    </div>
                  </div>
                  <div v-if="scope.row.model == '自定义创意'">
                    <div class="kImgBox">
                      <div
                        class="img"
                        :style="{'background-image':'url('+returnVideoUrl(scope.row.other_info.creative_vos[0].images[0].image_url)+')'}"
                      ></div>
                    </div>
                  </div>
                </template>
              </el-table-column>
              <el-table-column property="creative_id" fixed label="创意ID" width="150"></el-table-column>
              <el-table-column property="unit_name" fixed min-width="200" label="单元信息">
                  <template slot-scope="scope">
                    <p>标识：{{ scope.row.other_info.unit_id }}</p>
                    <p>名称：{{ scope.row.unit_name }}</p>
                  </template>
                </el-table-column>
              <el-table-column property="status_text" min-width="100" label="创建信息">
                <template slot-scope="scope">
                  <el-popover
                    v-if="scope.row.status_text != '成功'"
                    placement="top-start"
                    title="信息"
                    width="200"
                    trigger="hover"
                    :content="scope.row.status_text"
                  >
                    <el-button v-if="scope.row.status_text != '成功'" slot="reference" type="text">查看</el-button>
                  </el-popover>
                  <span v-if="scope.row.status_text == '成功'" type="text">成功</span>
                </template>
              </el-table-column>
              <el-table-column min-width="150" label="类型">
                <template slot-scope="scope">
                  <el-tag v-if="scope.row.model == '自定义创意'">{{ scope.row.model }}</el-tag>
                  <el-tag v-if="scope.row.model == '程序化创意'" type="danger">{{ scope.row.model }}</el-tag>
                </template>
              </el-table-column>
              <el-table-column min-width="200" label="创意名称">
                <template slot-scope="scope">
                  <el-tooltip v-if="scope.row.model == '自定义创意'" placement="top" effect="light">
                    <div slot="content">{{scope.row.creative_name}}</div>
                    <span
                      style="width: 180px;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;"
                      v-if="scope.row.model == '自定义创意'"
                    >{{scope.row.creative_name}}</span>
                  </el-tooltip>
                  <el-tooltip v-if="scope.row.model == '程序化创意' && scope.row.other_info.titles.length > 0" placement="top" effect="light">
                    <div slot="content">
                      <p
                        v-for="(item,index) in scope.row.other_info.titles"
                        :key="index"
                      >{{ item.title }}</p>
                    </div>
                    <p style="color:red" v-if="scope.row.model == '程序化创意'">多创意名称</p>
                  </el-tooltip>
                </template>
              </el-table-column>
              <el-table-column min-width="150" label="创意状态">
                <template slot-scope="scope">
                  <p>
                    <span v-if="scope.row.line_status == 0">暂无</span>
                    <span v-if="scope.row.line_status == 1">有效</span>
                    <span v-if="scope.row.line_status == 2">已暂停</span>
                    <span v-if="scope.row.line_status == 3">已完成</span>
                    <span v-if="scope.row.line_status == 4">已删除</span>
                    <span v-if="scope.row.line_status == 5">审核中</span>
                    <span v-if="scope.row.line_status == 6">审核拒绝</span>
                    <span v-if="scope.row.line_status == 7">修改待下线</span>
                    <span v-if="scope.row.line_status == 8">已下线</span>
                    <el-button
                      style="margin-left:5px"
                      type="text"
                      v-if="scope.row.creative_id != 0"
                      @click="refresh('adcreative',scope.row.id)"
                    >刷新</el-button>
                  </p>
                </template>
              </el-table-column>
              <el-table-column min-width="250" property="customized_click_url" label="监控地址">
                <template slot-scope="scope">
                  <el-tooltip placement="top" effect="light">
                    <div slot="content">
                      点击监控:{{scope.row.customized_click_url}}
                      <br />
                      展示监控:{{scope.row.customized_imp_url }}
                    </div>
                    <div>
                      <p
                        style="width: 200px;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;"
                        v-if="scope.row.customized_click_url"
                      >
                        <el-tag type="info" size="mini">点击:</el-tag>
                        {{scope.row.customized_click_url}}
                      </p>
                      <p
                        style="width: 200px;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;"
                        v-if="scope.row.customized_imp_url"
                      >
                        <el-tag type="info" size="mini">展示:</el-tag>
                        {{scope.row.customized_imp_url}}
                      </p>
                    </div>
                  </el-tooltip>
                </template>
              </el-table-column>
              <el-table-column min-width="180" label="账户信息">
                <template slot-scope="scope">
                  <el-tooltip placement="top">
                    <div slot="content">
                      ID:{{scope.row.account_id}}
                      <br />
                      名称:{{scope.row.aid_name}}
                    </div>
                    <p>ID:{{ scope.row.account_id }}</p>
                  </el-tooltip>
                  <p
                    style="width: 150px;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;"
                  >名称:{{ scope.row.aid_name }}</p>
                </template>
              </el-table-column>
              <el-table-column property="admin_id" min-width="100" label="创建人"></el-table-column>
              <el-table-column property="create_time" min-width="120" label="创建日期"></el-table-column>
              <el-table-column min-width="150" label="操作">
                <template slot-scope="scope">
                  <!-- <el-button
                    type="text"
                    v-if="scope.row.creative_id != 0"
                    @click="viewCreative(scope.row.aid,scope.row.creative_id)"
                  >预览</el-button>-->
                  <el-button
                    type="text"
                    @click="noMessage(scope.row.aid,scope.row.creative_id)"
                    v-if="scope.row.creative_id != 0"
                  >审核信息</el-button>
                  <!-- <el-button type="text" @click="editCreative(scope.row.id)">修改</el-button> -->
                  <template v-if="scope.row.line_status == 2">
                    <el-popconfirm
                      title="确定要启用当条记录吗？"
                      @confirm="editStatus('adcreativeDataTable', '1',[{'id':scope.row.id,'ad_id':scope.row.creative_id,'advertiser_id':scope.row.aid}])"
                    >
                      <el-button slot="reference" type="text">启用</el-button>
                    </el-popconfirm>
                  </template>
                  <template
                    v-if="scope.row.line_status == 1 || scope.row.line_status == 5 || scope.row.line_status == 6"
                  >
                    <el-popconfirm
                      title="确定要暂停当条记录吗？"
                      @confirm="editStatus('adcreativeDataTable', '2',[{'id':scope.row.id,'ad_id':scope.row.creative_id,'advertiser_id':scope.row.aid}])"
                    >
                      <el-button slot="reference" type="text">暂停</el-button>
                    </el-popconfirm>
                  </template>
                  <template
                    v-if="scope.row.creative_id && scope.row.creative_id != 0 && scope.row.line_status != 4"
                  >
                    <el-popconfirm
                      title="确定要删除当条记录吗？"
                      @confirm="editStatus('adcreativeDataTable', '3',[{'id':scope.row.id,'ad_id':scope.row.creative_id,'advertiser_id':scope.row.aid}])"
                    >
                      <el-button slot="reference" type="text">删除</el-button>
                    </el-popconfirm>
                  </template>
                </template>
              </el-table-column>
            </el-table>
            <el-pagination
              background
              @current-change="handleCurrentChangeAdcreative"
              :current-page="adcreativeDataTable.page | number"
              :page-sizes="[10, 20, 30, 40]"
              :page-size="adcreativeDataTable.pagesize | number"
              layout="total, prev, pager, next, jumper"
              :total="adcreativeDataTable.total | number"
            ></el-pagination>
          </div>
        </el-tab-pane>
      </el-tabs>
      <!-- 创建创意 -->
      <el-drawer
        title="批量创意"
        :visible.sync="dialogAdcreativeVisible"
        size="60%"
        direction="rtl"
          >
        <div class="rightDrawer">
          <div class="rightDrawerCenter">
            <el-row type="flex" justify="center">
                <el-col :span="24">
                  <el-form
                    ref="adcreativeForm"
                    :model="adcreativeForm"
                    :rules="rules.adcreative"
                    :size="size"
                    label-width="150px"
                    v-loading="adcreativeLoading"
                    >
                    <!-- 选这账户模块 -->
                    <el-card class="box-card" :shadow="hover">
                      <div slot="header" class="clearfix" :shadow="hover">
                        <span>账户</span>
                      </div>
                      <div>
                        <el-form-item label="投放账户" prop="advertiser_id">
                          <el-select
                            clearable
                            v-model="adcreativeForm.advertiser_id"
                            filterable
                            remote
                            placeholder="请输入关键词"
                            :remote-method="remoteAccountAdcreative"
                            @change="changeAccountAdcreative"
                            @clear="remoteAccountAdcreative"
                            :loading="loading"
                          >
                            <el-option
                              v-for="item in options.accounts_adcreatives"
                              :key="item.value"
                              :label="item.label"
                              :value="item.value"
                            ></el-option>
                          </el-select>
                        </el-form-item>
                        <el-form-item label="选择单元" prop="unit_id" v-if="adcreativeForm.advertiser_id">
                          <el-select
                            v-model="adcreativeForm.unit_id"
                            filterable
                            remote
                            multiple
                            reserve-keyword
                            placeholder="请输入关键词"
                            :remote-method="remoteAdgroup"
                            @change="changeAdgroup"
                            :loading="loading"
                          >
                            <el-option
                              v-for="item in options.adgroup_options"
                              :key="item.id"
                              :label="'【'+item.campaign_id+'】'+item.adgroup_id+'-'+item.unit_name"
                              :value="item.adgroup_id"
                            ></el-option>
                          </el-select>
                        </el-form-item>
                      </div>
                    </el-card>
                    <!-- 公共参数模块 -->
                    <el-card
                      class="box-card"
                      :shadow="hover"
                      v-if="adcreativeForm.advertiser_id && adcreativeForm.unit_id.length > 0"
                      >
                      <div slot="header" class="clearfix">
                        <span>公共参数</span>
                      </div>
                      <div>
                        
                        <el-form-item label="创意类型">
                          <el-radio-group
                            @input="creativeChange"
                            v-model="adcreativeForm.adcreative_type"
                          >
                            <el-radio-button label="1">自定义创意</el-radio-button>
                            <el-radio-button label="2" :disabled="sales_types == '11'">程序化创意</el-radio-button>
                          </el-radio-group>
                        </el-form-item>

                        <el-form-item label="投放模式">
                          <el-radio-group v-model="adcreativeForm.advertising_mode">
                            <el-radio-button label="0">常规投放</el-radio-button>
                            <el-radio-button label="1" disabled>内容投放</el-radio-button>
                          </el-radio-group>
                        </el-form-item>
                        <el-tabs type="card" v-model="adgroupTabsValue" v-if="adcreativeForm.prefer_scene.length > 0" style="margin-buttom:20px">
                          <el-tab-pane :label="'单元【'+iitem+'】'" :name="iitem" v-for="(iitem,iindex) in adcreativeForm.unit_id" :key="iitem">
                              <el-form-item label="投放场景" >
                                <el-radio-group v-model="adcreativeForm.prefer_scene[iindex].prefer_scene" @input="changeSience($event,iindex)">
                                  <el-radio-button label="1">优选广告位</el-radio-button>
                                  <el-radio-button label="0">指定场景</el-radio-button>
                                </el-radio-group>
                              </el-form-item>
                              <el-form-item v-if="adcreativeForm.prefer_scene[iindex].prefer_scene == 0" 
                              :prop="'prefer_scene.'+iindex+'.scene_ids'"
                              :rules="[{ validator: (rule, value, callback)=>{
                                if(value.length <= 0 && adcreativeForm.prefer_scene[iindex].prefer_scene == 0){
                                  callback('请选择场景')
                                }else{
                                  callback()
                                }
                              }, trigger: 'change' }]"
                              >
                                <el-checkbox-group v-model="adcreativeForm.prefer_scene[iindex].scene_ids">
                                  <el-checkbox
                                    v-for="item in adcreativeForm.prefer_scene[iindex].sceneOptions"
                                    :key="item.scene_id"
                                    :label="item.scene_id"
                                  >{{ item.scene_name }}</el-checkbox>
                                </el-checkbox-group>
                              </el-form-item>
                              <el-divider content-position="right"></el-divider>
                            </el-tab-pane>
                        </el-tabs>
                        <el-form-item label="展示监控URL">
                          <el-input
                            placeholder="请输入展示监控URL"
                            v-model="adcreativeForm.customized_imp_url"
                            clearable
                          ></el-input>
                        </el-form-item>
                        <el-form-item label="点击监控URL">
                          <el-input
                            placeholder="请输入点击监控URL"
                            v-model="adcreativeForm.customized_click_url"
                            clearable
                          ></el-input>
                        </el-form-item>
                        <template v-if="adcreativeForm.adcreative_type == '2'">
                          <el-form-item
                            :label="item.label"
                            v-for="(item,index) in adcreativeForm.creative_monitoring"
                            :key="index"
                          >
                            <el-input
                              :placeholder="'请输入'+item.label"
                              v-model="adcreativeForm.creative_monitoring[index].url"
                              clearable
                            ></el-input>
                          </el-form-item>
                        </template>
                        <el-form-item label="创意标签" prop="tags">
                          <el-tag
                            :key="tag"
                            v-for="tag in adcreativeForm.tags"
                            closable
                            effect="plain"
                            type="danger"
                            size="small"
                            style="margin-left:5px"
                            :disable-transitions="false"
                            @close="handleClose(tag)"
                          >{{tag}}</el-tag>
                          <el-input
                            class="input-new-tag"
                            v-if="inputVisible"
                            v-model="inputValue"
                            ref="saveTagInput"
                            style="width:50px;margin-left:5px"
                            size="mini"
                            @keyup.enter.native="handleInputConfirm"
                            @blur="handleInputConfirm"
                          ></el-input>
                          <el-button
                            v-else
                            style="margin-left:5px"
                            class="button-new-tag"
                            size="mini"
                            @click="showInput"
                          >+添加</el-button>
                        </el-form-item>
                        <el-form-item label="是否开启开放空间" prop="enable_space">
                          <el-select
                            @change="changeEnable"
                            v-model="adcreativeForm.enable_space"
                            placeholder="请选择"
                          >
                            <el-option
                              v-for="item in options.enable_options"
                              :key="item.value"
                              :label="item.label"
                              :value="item.value"
                            ></el-option>
                          </el-select>
                        </el-form-item>
                        <el-form-item
                          label="品牌信息"
                          prop="brand_info_id"
                          v-if="adcreativeForm.enable_space == '0'"
                        >
                          <el-select v-model="adcreativeForm.brand_info_id" placeholder="请选择品牌信息">
                            <el-option
                              v-for="item in options.brandOptions"
                              :key="item.id"
                              :label="item.brand_name"
                              :value="item.id"
                            >
                              <span style="float: left">{{ item.brand_name }}</span>
                              <span
                                class="imgCover"
                                :style="{'background-image':'url('+returnVideoUrl(item.face)+')'}"></span>
                            </el-option>
                          </el-select>
                        </el-form-item>
                        <el-form-item
                          label="开放空间"
                          prop="space_mid"
                          v-if="adcreativeForm.enable_space == '1'"
                        >
                          <el-select v-model="adcreativeForm.space_mid" placeholder="请选择开放空间">
                            <el-option
                              v-for="item in options.spaceOptions"
                              :key="item.mid"
                              :label="item.name"
                              :value="item.mid"
                            ></el-option>
                          </el-select>
                        </el-form-item>
                        <template v-if="adcreativeForm.adcreative_type == '2'">
                          <el-form-item label="补充资质">
                            <el-select
                              clearable
                              v-model="qualification_type"
                              placeholder="请选择补充资质"
                              @change="changePacks"
                            >
                              <el-option
                                v-for="item in options.pp_options"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value"
                              ></el-option>
                            </el-select>
                          </el-form-item>
                          <el-form-item label="补充资质" v-if="qualification_type == '1'">
                            <el-select
                              v-model="adcreativeForm.cx_creative_vos.qualification_ids"
                              placeholder="请选择"
                              multiple
                              filterable
                              remote
                              :remote-method="remoteMethodPages"
                            >
                              <el-option
                                v-for="item in options.page_options"
                                :key="item.id"
                                :label="item.name"
                                :value="item.id"
                              >
                                <span style="float: left">{{ item.name }}</span>
                                <span
                                  v-if="item.audit_status == 0"
                                  style="float: right; color: #8492a6; font-size: 13px"
                                >审核通过</span>
                                <span
                                  v-if="item.audit_status == 1"
                                  style="float: right; color: #8492a6; font-size: 13px"
                                >审核中</span>
                                <span
                                  v-if="item.audit_status == 2"
                                  style="float: right; color: #8492a6; font-size: 13px"
                                >审核拒绝</span>
                              </el-option>
                            </el-select>
                          </el-form-item>
                          <el-form-item label="资质包" v-if="qualification_type == '2'">
                            <el-select
                              v-model="adcreativeForm.cx_creative_vos.qualification_package_id"
                              placeholder="请选择"
                              clearable
                              filterable
                              remote
                              :remote-method="remoteMethodPackage"
                            >
                              <el-option
                                v-for="item in options.pack_options"
                                :key="item.id"
                                :label="item.name"
                                :value="item.id"
                              >
                                <el-tooltip class="item" effect="light" placement="right-start">
                                  <div slot="content">
                                    <el-tag
                                      style="margin-left:10px;"
                                      size="mini"
                                      v-for="(it,ii) in item.qualification_list"
                                      :key="ii"
                                    >{{it. qualification_name}}</el-tag>
                                  </div>
                                  <span>{{item.name}}</span>
                                </el-tooltip>
                              </el-option>
                            </el-select>
                          </el-form-item>
                        </template>
                        <el-form-item label="选取稿件" v-if="adcreativeForm.advertising_mode">
                          <el-button type="primary" @click="openbili()">选取稿件</el-button>
                        </el-form-item>
                      </div>
                    </el-card>
                    <!-- 程序化创意模块 -->
                    <el-card
                      class="box-card"
                      :shadow="hover"
                      v-if="adcreativeForm.cx_creative_vos.length > 0"
                      >
                      <div slot="header" class="clearfix">
                        <span>创意列表</span>
                      </div>
                      <el-tabs tab-position="right">
                          <el-tab-pane
                            v-for="(item,index) in adcreativeForm.cx_creative_vos"
                            :key="index"
                            :label="'程序化'+(index+1)"
                            >
                            <el-form-item label="稿件展示">
                              <div class="kImgBoxS">
                                <template v-if="'bili_video_media_list' in item.media_groups[0]">
                                  <template v-for="(it,i) in item.media_groups[0].bili_video_media_list" v-if="i<=3">
                                    <div class="img" :style="{'background-image':'url('+returnVideoUrl(it.video_cover.url)+')'}"></div>
                                  </template>
                                </template>
                                <template v-if="'mono_media_list' in item.media_groups[0]">
                                  <template v-for="(it,i) in item.media_groups[0].mono_media_list" v-if="i<=3">
                                    <div class="img" :style="{'background-image':'url('+returnVideoUrl(it.url)+')'}"></div>
                                  </template>
                                </template>
                              </div>
                            </el-form-item>         
                            <el-form-item
                              label="素材标题"
                              :prop="'cx_creative_vos.'+index+'.titles'"
                              :rules="[
                                        { validator: validateTitles, trigger: ['blur','change']}
                                      ]"
                              >
                              <p v-for="(itm,ii) in item.titles" :key="ii">
                                <el-input
                                  v-if="ii<=2"
                                  minlength="1"
                                  maxlength="18"
                                  show-word-limit
                                  placeholder="请输入素材标题"
                                  v-model="item.titles[ii].title"
                                  clearable
                                ></el-input>
                                <el-input
                                  v-if="ii>2"
                                  minlength="1"
                                  maxlength="18"
                                  show-word-limit
                                  placeholder="请输入素材标题"
                                  v-model="item.titles[ii].title"
                                  clearable
                                >
                                <el-button slot="append" icon="el-icon-close" @click="delTitles(index,ii)"></el-button>
                                </el-input>
                                <el-checkbox-group
                                  style="margin-top:10px;"
                                  v-model="item.titles[ii].arr"
                                  @change="addTitleInfo($event,ii,'cx_creative_vos')"
                                >
                                  <el-checkbox label="age">
                                    年龄
                                    <el-input
                                      v-if="item.titles[ii].arr.indexOf('age') != -1"
                                      v-model="item.titles[ii].age"
                                      style="width:50%"
                                      minlength="1"
                                      maxlength="6"
                                      show-word-limit
                                    ></el-input>
                                  </el-checkbox>
                                  <el-checkbox label="area">
                                    地域
                                    <el-input
                                      v-if="item.titles[ii].arr.indexOf('area') != -1"
                                      v-model="item.titles[ii].area"
                                      style="width:50%"
                                      minlength="1"
                                      maxlength="4"
                                      show-word-limit
                                    ></el-input>
                                  </el-checkbox>
                                  <el-checkbox label="gender">
                                    性别
                                    <el-input
                                      v-if="item.titles[ii].arr.indexOf('gender') != -1"
                                      v-model="item.titles[ii].gender"
                                      style="width:50%"
                                      minlength="1"
                                      maxlength="1"
                                      show-word-limit
                                    ></el-input>
                                  </el-checkbox>
                                  <el-checkbox label="device">
                                    设备
                                    <el-input
                                      v-if="item.titles[ii].arr.indexOf('device') != -1"
                                      v-model="item.titles[ii].device"
                                      style="width:50%"
                                      minlength="1"
                                      maxlength="2"
                                      show-word-limit
                                    ></el-input>
                                  </el-checkbox>
                                </el-checkbox-group>
                              </p>
                              <p>
                                <el-button
                                  type="primary"
                                  size="mini"
                                  icon="el-icon-plus"
                                  @click="addTitles(index)"
                                >添加标题</el-button>
                              </p>
                            </el-form-item>
                            <el-form-item
                              label="素材描述"
                              :prop="'cx_creative_vos.'+index+'.description'"
                              :rules="[
                                        { required: true, message: '请输入描述', trigger: 'blur' }
                                      ]"
                              >
                              <el-input
                                minlength="1"
                                maxlength="10"
                                show-word-limit
                                placeholder="请输入素材描述"
                                v-model="item.description"
                                clearable
                              ></el-input>
                            </el-form-item>
                            <el-form-item label="素材长描述">
                              <el-input
                                minlength="1"
                                maxlength="32"
                                show-word-limit
                                placeholder="请输入素材长描述"
                                v-model="item.ext_description"
                                clearable
                              ></el-input>
                            </el-form-item>
                            <el-form-item
                              label="分类"
                              :prop="'cx_creative_vos.'+index+'.categorys'"
                              :rules="[
                                        { type:'array',required: true, message: '请选择分类', trigger: 'change' }
                                      ]"
                              >
                              <el-cascader
                                v-model="item.categorys"
                                :options="options.category_options"
                              ></el-cascader>
                            </el-form-item>
                            <el-form-item
                              label="落地页"
                              :prop="'cx_creative_vos.'+index+'.jump_type'"
                              :rules="[
                              {required: true, message: '落地页类型必选'}
                              ]"
                              >
                              <el-select
                                @change="changepage"
                                v-model="item.jump_type"
                                placeholder="请选择"
                              >
                                <el-option label="链接" value="1"></el-option>
                                <el-option label="建站工具" value="5"></el-option>
                              </el-select>
                            </el-form-item>
                            <el-form-item
                              label="落地页链接"
                              v-if="item.jump_type == '1'"
                              :prop="'cx_creative_vos.'+index+'.promotion_purpose_content'"
                              :rules="[
                              {required: true, message: '落地页链接必填'}
                              ]"
                              >
                              <el-input
                                v-model="item.promotion_purpose_content"
                                placeholder="请输入内容"
                              ></el-input>
                            </el-form-item>
                            <el-form-item
                              label="建站工具"
                              v-if="item.jump_type == '5'"
                              :prop="'cx_creative_vos.'+index+'.promotion_purpose_content'"
                              :rules="[
                              {required: true, message: '建站工具必填'}
                              ]"
                              >
                              <el-select
                                v-model="item.promotion_purpose_content"
                                placeholder="请选择"
                              >
                                <el-option
                                  v-for="item in options.zhan_options"
                                  :key="item.value"
                                  :label="item.name"
                                  :value="item.value"
                                ></el-option>
                              </el-select>
                            </el-form-item>
                          </el-tab-pane>
                        </el-tabs>
                    </el-card>
                    <!-- 自定义创意模块 -->
                    <el-card
                      class="box-card"
                      :shadow="hover"
                      v-if="(adcreativeForm.videos.length>0 || adcreativeForm.images.length>0) && adcreativeForm.adcreative_type == '1'"
                      >
                      <div slot="header" class="clearfix">
                        <span>创意列表</span>
                      </div>
                      <div>
                        <el-tabs tab-position="right">
                          <el-tab-pane
                            v-for="(item,index) in selectVideos"
                            :key="index"
                            :label="'自定义'+(index+1)"
                          >
                            <el-form-item label="稿件展示">
                              <div class="kImgBox">
                                <div
                                  v-if="item.type=='VIDEO'"
                                  class="img"
                                  :style="{'background-image':'url('+returnVideoUrl(item.cover.url)+')'}"
                                ></div>
                                <div
                                  v-if="item.type=='IMAGE'"
                                  class="img"
                                  :style="{'background-image':'url('+returnVideoUrl(item.mediaUrl)+')'}"
                                ></div>
                              </div>
                              <!-- <img v-if="item.type=='VIDEO'" :src="item.cover.url" />
                              <img v-if="item.type=='IMAGE'" :src="item.mediaUrl" />-->
                            </el-form-item>
                            <el-form-item
                              label="创意名称"
                              :prop="'creative_vos.'+index+'.creative_name'"
                              :rules="[
                                  { required: true, message: '请输入创意名称', trigger: 'blur' }
                              ]"
                            >
                              <el-input
                                placeholder="请输入创意名称"
                                v-model="adcreativeForm.creative_vos[index].creative_name"
                                clearable
                              ></el-input>
                            </el-form-item>
                            <el-form-item
                              label="动态配文"
                              :prop="'creative_vos.'+index+'.title'"
                              :rules="[
                                  { required: true, message: '请输入动态配文', trigger: 'blur' }
                                ]"
                            >
                              <el-input
                                minlength="0"
                                maxlength="40"
                                show-word-limit
                                placeholder="请输入动态配文"
                                v-model="adcreativeForm.creative_vos[index].title"
                                clearable
                              ></el-input>
                            </el-form-item>
                            <el-form-item
                              label="动态描述"
                              :prop="'creative_vos.'+index+'.description'"
                              :rules="[
                                  { required: true, message: '请输入动态描述', trigger: 'blur' }
                                ]"
                            >
                              <el-input
                                minlength="0"
                                maxlength="18"
                                show-word-limit
                                placeholder="请输入动态描述"
                                v-model="adcreativeForm.creative_vos[index].description"
                                clearable
                              ></el-input>
                            </el-form-item>
                            <el-form-item
                              label="分类"
                              :prop="'creative_vos.'+index+'.categorys'"
                              :rules="[
                                  { required: true, message: '请选择分类', trigger: 'change' }
                                ]"
                            >
                              <el-cascader
                                v-model="adcreativeForm.creative_vos[index].categorys"
                                :options="options.category_options"
                              ></el-cascader>
                            </el-form-item>
                            <el-form-item label="是否含有按钮">
                              <el-radio-group
                                @input="changeButton($event,index)"
                                v-model="adcreativeForm.creative_vos[index].attach_type"
                              >
                                <el-radio-button label="0">无</el-radio-button>
                                <el-radio-button label="1">有</el-radio-button>
                              </el-radio-group>
                            </el-form-item>
                            <template v-if="adcreativeForm.creative_vos[index].attach_type == '1'">
                              <el-form-item label="按钮文案">
                                <el-select
                                  v-model="adcreativeForm.creative_vos[index].button_copy_id"
                                  placeholder="请选择按钮文案"
                                >
                                  <el-option
                                    v-for="item in options.buttons_options"
                                    :key="item.id"
                                    :label="item.content"
                                    :value="item.id"
                                  ></el-option>
                                </el-select>
                              </el-form-item>
                              <el-form-item label="广告标识">
                                <el-select
                                  v-model="adcreativeForm.creative_vos[index].bus_mark_id"
                                  placeholder="请选择广告标识"
                                >
                                  <el-option
                                    v-for="item in options.marks_options"
                                    :key="item.id"
                                    :label="item.name"
                                    :value="item.id"
                                  ></el-option>
                                </el-select>
                              </el-form-item>
                            </template>
                            <el-form-item label="是否允许分享">
                              <el-radio-group v-model="adcreativeForm.creative_vos[index].share_state">
                                <el-radio-button label="0">关闭</el-radio-button>
                                <el-radio-button label="1">开启</el-radio-button>
                              </el-radio-group>
                            </el-form-item>
                            <el-form-item
                              label="落地页"
                              :prop="'creative_vos.'+index+'.jump_type'"
                              :rules="[
                      {required: true, message: '建站工具必填'}
                      ]"
                            >
                              <el-select
                                @change="changepage"
                                v-model="adcreativeForm.creative_vos[index].jump_type"
                                placeholder="请选择"
                              >
                                <el-option label="链接" value="1"></el-option>
                                <el-option label="建站工具" value="5"></el-option>
                              </el-select>
                            </el-form-item>
                            <el-form-item
                              label="落地页链接"
                              v-if="adcreativeForm.creative_vos[index].jump_type == '1'"
                              :prop="'creative_vos.'+index+'.promotion_purpose_content'"
                              :rules="[
                      {required: true, message: '落地页链接必填'}
                      ]"
                            >
                              <el-input
                                v-model="adcreativeForm.creative_vos[index].promotion_purpose_content"
                                placeholder="请输入内容"
                              ></el-input>
                            </el-form-item>
                            <el-form-item
                              label="建站工具"
                              v-if="adcreativeForm.creative_vos[index].jump_type == '5'"
                              :prop="'creative_vos.'+index+'.promotion_purpose_content'"
                              :rules="[
                      {required: true, message: '建站工具必填'}
                      ]"
                            >
                              <el-select
                                v-model="adcreativeForm.creative_vos[index].promotion_purpose_content"
                                placeholder="请选择"
                              >
                                <el-option
                                  v-for="item in options.zhan_options"
                                  :key="item.value"
                                  :label="item.name"
                                  :value="item.value"
                                ></el-option>
                              </el-select>
                            </el-form-item>
                            <template v-if="adcreativeForm.adcreative_type == '2'">
                              <el-form-item label="补充资质">
                                <el-select
                                  clearable
                                  v-model="qualification_type"
                                  placeholder="请选择补充资质"
                                  @change="changePacks"
                                >
                                  <el-option
                                    v-for="item in options.pp_options"
                                    :key="item.value"
                                    :label="item.label"
                                    :value="item.value"
                                  ></el-option>
                                </el-select>
                              </el-form-item>
                              <el-form-item label="补充资质" v-if="qualification_type == '1'">
                                <el-select
                                  v-model="adcreativeForm.creative_vos[index].qualification_ids"
                                  placeholder="请选择"
                                  multiple
                                  filterable
                                  remote
                                  :remote-method="remoteMethodPages"
                                >
                                  <el-option
                                    v-for="item in options.page_options"
                                    :key="item.id"
                                    :label="item.name"
                                    :value="item.id"
                                  >
                                    <span style="float: left">{{ item.name }}</span>
                                    <span
                                      v-if="item.audit_status == 0"
                                      style="float: right; color: #8492a6; font-size: 13px"
                                    >审核通过</span>
                                    <span
                                      v-if="item.audit_status == 1"
                                      style="float: right; color: #8492a6; font-size: 13px"
                                    >审核中</span>
                                    <span
                                      v-if="item.audit_status == 2"
                                      style="float: right; color: #8492a6; font-size: 13px"
                                    >审核拒绝</span>
                                  </el-option>
                                </el-select>
                              </el-form-item>
                              <el-form-item label="资质包" v-if="qualification_type == '2'">
                                <el-select
                                  style="width:50%;"
                                  v-model="adcreativeForm.creative_vos[index].qualification_package_id"
                                  placeholder="请选择"
                                  clearable
                                  filterable
                                  remote
                                  :remote-method="remoteMethodPackage"
                                >
                                  <el-option
                                    v-for="item in options.pack_options"
                                    :key="item.id"
                                    :value="item.id"
                                  >
                                    <el-tooltip class="item" effect="light" placement="right-start">
                                      <div slot="content">
                                        <el-tag
                                          style="margin-left:10px;"
                                          size="mini"
                                          v-for="(it,ii) in item.qualification_list"
                                          :key="ii"
                                        >{{it. qualification_name}}</el-tag>
                                      </div>
                                      <span>{{item.name}}</span>
                                    </el-tooltip>
                                  </el-option>
                                </el-select>
                              </el-form-item>
                            </template>
                          </el-tab-pane>
                        </el-tabs>
                      </div>
                    </el-card>
                  </el-form>
                </el-col>
            </el-row>
            <el-row type="flex" justify="end" v-if="adcreativeForm.advertiser_id && adcreativeForm.unit_id.length > 0">
                  <el-col :span="6">
                      <el-button @click="dialogAdcreativeVisible = false" size="medium">取 消</el-button>
                      <el-button
                      @click="createAdcreative('adcreativeForm')"
                          type="primary"
                          size="medium"
                      >确定</el-button>
                  </el-col>
            </el-row>
          </div>
        </div>
      </el-drawer>
      <!-- 稿件库 -->
      <el-dialog
        v-loading="sourceLoading"
        title="稿件库"
        :visible.sync="dialogTableVisible"
        custom-class="target-dialog"
        width="95%"
        top="30px"
        >
        <div class="sourceBox">
          <div class="sourceBoxTop">
            <el-select
              size="mini"
              @change="templateChange"
              v-model="contentDataTable.template"
              placeholder="请选择"
            >
              <el-option
                v-for="item in options.template_options"
                :key="item.simple_template_group.id"
                :label="item.simple_template_group.tg_name"
                :value="item.simple_template_group.id"
              ></el-option>
            </el-select>
            <el-input
              style="width: 200px;margin-left:10px;"
              clearable
              placeholder="素材名称(可模糊查询)"
              :size="size"
              v-model="contentDataTable.name"
            >
              <el-button slot="append" @click="changeBlibliVideo(1)">查询</el-button>
            </el-input>
            <el-input-number :disabled="adcreativeForm.adcreative_type == '1'" style="width: 200px;margin-left:10px;" :size="size" v-model="num" :min="adcreativeForm.adcreative_type == '1' ? 1 : 2" :max="6" label="分组"></el-input-number>
          </div>
          <div class="sourceBoxCen">
            <div class="sourceBoxCenCon" style="width: calc(100% - 440px);">
              <div class="sourceHeader">
                <div>稿件列表</div>
                <div style="display: flex;">
                  <el-link
                    type="primary"
                    icon="el-icon-check"
                    :size="size"
                    @click="allSelect(true)"
                  >全选</el-link>
                  <el-link
                    type="primary"
                    icon="el-icon-close"
                    :size="size"
                    @click="allSelect(false)"
                  >取消</el-link>&nbsp;
                  &nbsp;
                  <!-- <el-link icon="el-icon-upload" type="primary" :size="size">同步素材</el-link> -->
                </div>
              </div>
              <div class="sourceCenter">
                <div class="sourceOption">
                  <div
                    class="material-component"
                    v-for="(item,index) in contentDataTable.data"
                    :key="index"
                  >
                    <div class="block-mid-lis" v-if="item.type == 'VIDEO'">
                      <div class="mid-lis-img" @click="changeVideo('add',index,item.display)">
                        <div class="imgBox-Box not-dragging">
                          <img :src="returnVideoUrl(item.cover.url)" class="imgBox-img" />
                        </div>
                        <div class="adesk__material-use-status status-2">视频</div>
                      </div>
                      <div class="mask-cover" v-show="item.display">
                        <i class="el-icon-check"></i>
                      </div>
                      <el-popover placement="top-start" title="信息" width="400" trigger="hover">
                        <p>稿件ID:&nbsp;{{item.ugc.cid}}</p>
                        <p>用户ID:&nbsp;{{item.ugc.mid}}</p>
                        <p>名称:&nbsp;{{ item.video.name }}</p>
                        <p>尺寸:&nbsp;{{item.video.width}}X{{ item.video.height }}</p>
                        <p>标签:&nbsp;{{returnVideoTags(item.ugc.tags)}}</p>
                        <div class="mid-lis-title" slot="reference">{{item.video.name}}</div>
                      </el-popover>
                    </div>
                    <div class="block-mid-lis" v-if="item.type == 'IMAGE'">
                      <div class="mid-lis-img" @click="changeVideo('add',index,item.display)">
                        <div class="imgBox-Box not-dragging">
                          <img :src="returnVideoUrl(item.mediaUrl)" class="imgBox-img" />
                        </div>
                        <div class="adesk__material-use-status status-0">图片</div>
                      </div>
                      <div class="mask-cover" v-show="item.display">
                        <i class="el-icon-check"></i>
                      </div>
                      <el-popover placement="top-start" title="信息" width="400" trigger="hover">
                        <p>图片ID:&nbsp;{{item.id}}</p>
                        <p>名称:&nbsp;{{ item.mediaName }}</p>
                        <p>尺寸:&nbsp;{{item.width}}X{{ item.height }}</p>
                        <div class="mid-lis-title" slot="reference">{{item.mediaName}}</div>
                      </el-popover>
                    </div>
                  </div>
                </div>
                <div class="sourceOptionPage"></div>
              </div>
            </div>
            <div class="sourceBoxCenRight" style="width: 440px;">
              <div class="sourceHeader">
                <div>已选稿件</div>
                <div style="color: #007AD6; cursor: pointer;">
                  <!-- <span>批量封面</span> -->
                  <span @click="clearAll">清空已选</span>
                </div>
              </div>
              <div class="sourceCenter">
                <div class="sourceSelect">
                  <div :class="dynamicClasses(index)" v-for="(item,index) in selectVideos" :key="index">
                    <div class="material-info-base">
                      <div class="image" v-if="item.type=='VIDEO'">
                        <img :src="returnVideoUrl(item.cover.url)" />
                      </div>
                      <div class="image" v-if="item.type=='IMAGE'">
                        <img :src="returnVideoUrl(item.mediaUrl)" />
                      </div>
                      <div class="material-name double-ellipsis">
                        <template v-if="item.type=='VIDEO'">
                          <p class="mid-lis-title">
                            <i class="creative-templeate-tag t1">视频</i>
                            {{item.video.name}}
                          </p>
                          <p class="mid-lis-title">
                            <el-switch v-model="item.value"></el-switch>
                            <span style="margin-left:5px;">是否开启弹幕</span>
                          </p>
                        </template>
                        <template v-if="item.type=='IMAGE'">
                          <p class="mid-lis-title">
                            <i class="creative-templeate-tag t1">图片</i>
                            {{item.mediaName}}
                          </p>
                        </template>
                      </div>
                    </div>
                    <div class="material-delete">
                      <i class="el-icon-delete" @click="changeVideo('del',index,item)"></i>
                    </div>                     
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div slot="footer" class="dialog-footer" style="text-align: center;">
          <el-button :size="size" @click="dialogTableVisible = false">取 消</el-button>
          <el-button :size="size" type="primary" @click="initSource">确 定</el-button>
        </div>
      </el-dialog>
      <!-- 批量创建抽屉 -->
      <el-drawer
            title="批量单元"
            :visible.sync="drawer"
            size="50%"
            direction="rtl"
            >
            <div class="rightDrawer">
                <div class="rightDrawerCenter" v-loading="drawerLoading">
                    <el-row type="flex" justify="center">
                        <el-col :span="24">
                            <el-form
                            ref="batchForm"
                            label-position="right"
                            :model="batchForm"
                            :rules="rules"
                            :size="size"
                            label-width="130px"
                            v-loading="adgroupLoading"
                            >
                                <!-- 账户 -->
                                <el-card class="box-card" :shadow="hover">
                                    <div slot="header" class="clearfix">
                                        <span>账户</span>
                                    </div>
                                    <el-form-item label="投放账户" prop="advertiser_id">
                                        <el-select
                                            clearable
                                            v-model="batchForm.advertiser_id"
                                            filterable
                                            remote
                                            reserve-keyword
                                            placeholder="请输入关键词"
                                            :remote-method="remoteAccount"
                                            @change="changeAccountAdgroup"
                                            :loading="loading"
                                        >
                                            <el-option
                                            v-for="item in options.accounts"
                                            :key="item.value"
                                            :label="item.label"
                                            :value="item.value"
                                            ></el-option>
                                        </el-select>
                                    </el-form-item>
                                </el-card>
                                <!-- 创建计划 -->
                                <el-card class="box-card" :shadow="hover" v-if="batchForm.advertiser_id">
                                    <div slot="header" class="clearfix">
                                        <span>计划</span>
                                    </div>
                                    <el-form-item label="计划名称" prop="campaignForm.campaign_name">
                                        <el-input v-model="batchForm.campaignForm.campaign_name" placeholder="请输入计划名称"></el-input>
                                    </el-form-item>
                                    <el-form-item label="推广目的" v-show="batchForm.advertiser_id">
                                        <el-radio-group
                                            v-model="batchForm.campaignForm.promotion_purpose_type"
                                        >
                                            <el-tooltip
                                            v-for="(item,index) in options.launchTypes"
                                            :key="index"
                                            class="item"
                                            effect="dark"
                                            placement="top"
                                            >
                                            <div slot="content">
                                                {{item.content}}
                                                <br />
                                                {{ item.tips}}
                                            </div>
                                            <el-radio-button :label="item.id">{{item.name}}</el-radio-button>
                                            </el-tooltip>

                                            <!-- <el-radio-button label="7">提高应用活跃</el-radio-button> -->
                                        </el-radio-group>
                                    </el-form-item>
                                    <el-form-item label="预算类型">
                                    <el-radio-group v-model="batchForm.campaignForm.budget_limit_type">
                                        <el-radio-button label="1">指定预算</el-radio-button>
                                        <el-radio-button label="2">不限预算</el-radio-button>
                                    </el-radio-group>
                                    </el-form-item>
                                    <el-form-item label="预算金额" v-if="batchForm.campaignForm.budget_limit_type == 1">
                                        <el-input-number
                                            v-model="batchForm.campaignForm.budget"
                                            :precision="2"
                                            :step="0.1"
                                            :min="500"
                                            :max="9999999.99"
                                        ></el-input-number>
                                    </el-form-item>
                                </el-card>
                                <!-- 单元模块 -->
                                <el-card
                                    class="box-card"
                                    :shadow="hover"
                                    v-if="batchForm.advertiser_id">
                                    <div slot="header" class="clearfix">
                                        <span>单元</span>
                                    </div>
                                    <div>
                                        <el-form-item label="单元名称" prop="adgroupForm.unit_name">
                                            <el-input v-model="batchForm.adgroupForm.unit_name" placeholder="请输入单元名称"></el-input>
                                        </el-form-item>
                                        <template v-if="promotion_purpose_type == '15'">
                                            <el-form-item
                                            label="单元推广目的"
                                            prop="adgroupForm.unit_promotion_purpose_type">
                                            <el-radio-group v-model="batchForm.adgroupForm.unit_promotion_purpose_type">
                                                <el-radio-button label="7">投稿内容</el-radio-button>
                                            </el-radio-group>
                                            </el-form-item>
                                        </template> 
                                        <template v-if="promotion_purpose_type == '6'">
                                            <el-form-item label="APP包ID" prop="adgroupForm.app_package_id">
                                                <el-select v-model="batchForm.adgroupForm.app_package_id" placeholder="请选择APP包ID">
                                                <el-option
                                                    v-for="item in options.appOptions"
                                                    :key="item.id"
                                                    :label="item.app_package_name"
                                                    :value="item.id"
                                                ></el-option>
                                                </el-select>
                                            </el-form-item>
                                        </template>
                                        <template v-if="promotion_purpose_type == '6'">
                                            <el-form-item label="游戏ID" prop="adgroupForm.game_base_id">
                                                <el-select v-model="batchForm.adgroupForm.game_base_id" placeholder="请选择游戏ID">
                                                <el-option
                                                    v-for="item in options.gameOptions"
                                                    :key="item.game_base_id"
                                                    :label="item.game_name"
                                                    :value="item.game_base_id"
                                                ></el-option>
                                                </el-select>
                                            </el-form-item>
                                        </template>
                                        <template v-if="promotion_purpose_type == '8'">
                                            <el-form-item label="直播间ID" prop="adgroupForm.material_id">
                                            <el-input
                                            placeholder="请输入直播间ID"
                                            v-model="batchForm.adgroupForm.material_id"
                                            clearable
                                            ></el-input>
                                            </el-form-item>
                                        </template>
                                        <template v-if="promotion_purpose_type == '4'">
                                            <el-form-item label="APP包ID" prop="adgroupForm.app_package_id">
                                                <el-select v-model="batchForm.adgroupForm.app_package_id" placeholder="请选择APP包ID">
                                                <el-option
                                                    v-for="item in options.appOptions"
                                                    :key="item.id"
                                                    :label="item.app_package_name"
                                                    :value="item.id"
                                                ></el-option>
                                                </el-select>
                                            </el-form-item>
                                            <el-form-item label="是否应用商店直投" prop="adgroupForm.is_store_direct_launch">
                                                <el-radio-group v-model="batchForm.adgroupForm.is_store_direct_launch">
                                                <el-radio-button label="0">否</el-radio-button>
                                                <el-radio-button label="1">是</el-radio-button>
                                                </el-radio-group>
                                            </el-form-item>
                                        </template>
                                        <el-form-item label="排期开始时间" prop="adgroupForm.begin_date">
                                            <el-date-picker
                                                :picker-options="pickerOptions"
                                                placement="bottom-start"
                                                v-model="batchForm.adgroupForm.begin_date"
                                                value-format="yyyy-MM-dd"
                                                type="date"
                                                placeholder="选择日期"
                                            ></el-date-picker>
                                        </el-form-item>
                                        <el-form-item label="排期结束时间" prop="adgroupForm.end_date">
                                            <el-date-picker
                                                :picker-options="pickerOptions"
                                                placement="bottom-start"
                                                v-model="batchForm.adgroupForm.end_date"
                                                value-format="yyyy-MM-dd"
                                                type="date"
                                                placeholder="选择日期"
                                            ></el-date-picker>
                                        </el-form-item>
                                        <el-form-item label="时段" prop="adgroupForm.launch_time">
                                            <el-input v-model="batchForm.adgroupForm.launch_time" readonly style="width:300px">
                                                <el-button
                                                slot="append"
                                                icon="el-icon-thumb"
                                                @click="scheduleTimeVisible = true"
                                                >选择时段</el-button>
                                            </el-input>
                                            <BTime
                                                :visible.sync="scheduleTimeVisible"
                                                :time.sync="batchForm.adgroupForm.launch_time"
                                            ></BTime>
                                        </el-form-item>
                                        <el-form-item label="频次限制" prop="adgroupForm.frequency_unit">
                                            <el-radio-group v-model.number="batchForm.adgroupForm.frequency_unit">
                                                <el-radio-button label="1">每日</el-radio-button>
                                                <el-radio-button label="2">每周</el-radio-button>
                                            </el-radio-group>
                                        </el-form-item>
                                        <el-form-item label="频次次数" prop="adgroupForm.frequency_limit">
                                            <el-input-number v-model="batchForm.adgroupForm.frequency_limit" :step="1"></el-input-number>
                                        </el-form-item>
                                        <el-form-item label="售卖类型" prop="adgroupForm.sales_type">
                                            <el-radio-group v-model="batchForm.adgroupForm.sales_type">
                                                <el-radio-button label="12_ocpc">OCPC</el-radio-button>
                                                <el-radio-button label="12_cpc">CPC</el-radio-button>
                                                <el-radio-button label="11_cpm">CPM</el-radio-button>
                                            </el-radio-group>
                                        </el-form-item>
                                        <el-form-item label="日预算" prop="adgroupForm.budget">
                                            <el-input-number
                                                v-model="batchForm.adgroupForm.budget"
                                                :precision="2"
                                                :step="0.1"
                                                :min="500"
                                                :max="9999999.99"
                                            ></el-input-number>
                                        </el-form-item>
                                        <el-form-item label="出价" prop="adgroupForm.cost_price">
                                            <el-input-number
                                                v-model="batchForm.adgroupForm.cost_price"
                                                :precision="2"
                                                :step="0.1"
                                                :min="returncost(batchForm.adgroupForm.sales_type)"
                                                :max="9999999.99"
                                            ></el-input-number>
                                        </el-form-item>
                                        <template v-if="batchForm.adgroupForm.sales_type == '12_ocpc'">
                                            <el-form-item label="OCPC阶段2:出价" prop="adgroupForm.two_stage_bid">
                                                <el-input-number
                                                v-model="batchForm.adgroupForm.two_stage_bid"
                                                :precision="2"
                                                :step="0.1"
                                                :min="0.5"
                                                :max="9999999.99"
                                                ></el-input-number>
                                            </el-form-item>
                                            <el-form-item label="优化目标" prop="adgroupForm.ocpx_target">
                                                <el-select v-model="batchForm.adgroupForm.ocpx_target" placeholder="请选择OCPX优化目标">
                                                    <el-option
                                                        v-for="item in returnsalasType(batchForm.adgroupForm.sales_type)"
                                                        :key="item.id"
                                                        :label="item.name"
                                                        :value="item.id"
                                                    ></el-option>
                                                    </el-select>
                                            </el-form-item>
                                            <el-form-item label="是否开启深度优化目标" prop="adgroupForm.enable_ocpc">
                                                <el-radio-group v-model="batchForm.adgroupForm.enable_ocpc">
                                                <el-radio-button label="true">开启</el-radio-button>
                                                <el-radio-button label="false">关闭</el-radio-button>
                                                </el-radio-group>
                                            </el-form-item>
                                            <template v-if="batchForm.adgroupForm.enable_ocpc == 'true'">
                                                    <el-form-item label="OCPX优化目标" prop="adgroupForm.ocpx_target_two">
                                                        <el-select v-model="batchForm.adgroupForm.ocpx_target_two" placeholder="请选择APP包ID">
                                                            <el-option
                                                            v-for="item in returnsalasTwo(batchForm.adgroupForm.sales_type,adgroupForm.ocpx_target)"
                                                            :key="item.id"
                                                            :label="item.name"
                                                            :value="item.id"
                                                            ></el-option>
                                                        </el-select>
                                                    </el-form-item>
                                                    <el-form-item label="深度转化出价" prop="adgroupForm.ocpx_target_two_bid ">
                                                        <el-input-number
                                                            v-model="batchForm.adgroupForm.ocpx_target_two_bid"
                                                            :precision="2"
                                                            :step="0.1"
                                                            :min="0"
                                                            :max="9999999.99"
                                                        ></el-input-number>
                                                    </el-form-item>
                                            </template>
                                        </template>
                                        <el-form-item label="加速模式" prop="adgroupForm.speed_mode">
                                            <el-radio-group v-model="batchForm.adgroupForm.speed_mode">
                                                <el-radio-button label="1">匀速</el-radio-button>
                                                <el-radio-button label="2">加速</el-radio-button>
                                            </el-radio-group>
                                        </el-form-item>
                                    </div>
                                </el-card>
                                <!-- 用户定向模块 -->
                                <el-card class="box-card" :shadow="hover" v-if="batchForm.advertiser_id">
                                    <div slot="header" class="clearfix">
                                        <span>定向</span>
                                    </div>
                                    <div>
                                        <el-tabs type="card" v-model="editableTabsValue" editable  @edit="handleTabsEdit">
                                            <el-tab-pane :label="'定向'+(iindex+1)" :name="iitem.name" v-for="(iitem,iindex) in batchForm.adgroupForm.targets" :key="iitem.name">
                                               
                                                <el-form-item label="年龄定向">
                                                    <el-radio-group v-model="iitem.isShowType.age_type">
                                                        <el-radio-button label="CLOSE">关闭</el-radio-button>
                                                        <el-radio-button label="OPEN">开启</el-radio-button>
                                                    </el-radio-group>
                                                </el-form-item>
                                                <el-form-item v-if="iitem.isShowType.age_type == 'OPEN'">
                                                    <el-checkbox-group v-model="iitem.age">
                                                        <el-checkbox
                                                        v-for="it in options.age_options"
                                                        :key="it.id"
                                                        :label="it.id"
                                                        >{{ it.name}}</el-checkbox>
                                                    </el-checkbox-group>
                                                </el-form-item>
                                            
                                                <el-form-item label="性别定向">
                                                    <el-radio-group v-model="iitem.isShowType.gender_type">
                                                        <el-radio-button label="CLOSE">关闭</el-radio-button>
                                                        <el-radio-button label="OPEN">开启</el-radio-button>
                                                    </el-radio-group>
                                                </el-form-item>
                                                <el-form-item v-if="iitem.isShowType.gender_type == 'OPEN'">
                                                    <el-checkbox-group v-model="iitem.gender">
                                                        <el-checkbox
                                                        v-for="(it,ix) in options.gender_options"
                                                        :key="ix"
                                                        :label="it.id"
                                                        >{{ it.name}}</el-checkbox>
                                                    </el-checkbox-group>
                                                </el-form-item>

                                                <el-form-item label="地域定向">
                                                    <el-radio-group v-model="iitem.isShowType.area_type">
                                                        <el-radio-button label="CLOSE">关闭</el-radio-button>
                                                        <el-radio-button label="OPEN">开启</el-radio-button>
                                                    </el-radio-group>
                                                </el-form-item>
                                                <el-form-item v-if="iitem.isShowType.area_type == 'OPEN'">
                                                    <el-cascader-panel
                                                        :props="propp"
                                                        :options="options.area_options"
                                                        v-model="iitem.area"
                                                    ></el-cascader-panel>
                                                </el-form-item>

                                                <el-form-item label="设备定向">
                                                  <el-radio-group v-model="iitem.isShowType.os_type">
                                                    <el-radio-button label="CLOSE">关闭</el-radio-button>
                                                    <el-radio-button label="OPEN">开启</el-radio-button>
                                                  </el-radio-group>
                                                </el-form-item>
                                                <el-form-item v-if="iitem.isShowType.os_type == 'OPEN'">
                                                  <el-checkbox-group v-model="iitem.os">
                                                    <el-checkbox
                                                      v-for="(it,ix) in options.os_options"
                                                      :key="ix"
                                                      :label="it.id"
                                                    >{{ it.name}}</el-checkbox>
                                                  </el-checkbox-group>
                                                </el-form-item>  

                                                <el-form-item label="设备品牌">
                                                  <el-radio-group v-model="iitem.isShowType.brand_type">
                                                    <el-radio-button label="CLOSE">关闭</el-radio-button>
                                                    <el-radio-button label="OPEN">开启</el-radio-button>
                                                  </el-radio-group>
                                                </el-form-item>
                                                <el-form-item v-if="iitem.isShowType.brand_type == 'OPEN'">
                                                  <el-checkbox-group v-model="iitem.device_brand">
                                                    <el-checkbox
                                                      v-for="(it,ix) in options.device_brand_options"
                                                      :key="ix"
                                                      :label="it.id"
                                                    >{{ it.name}}</el-checkbox>
                                                  </el-checkbox-group>
                                                </el-form-item>

                                                <el-form-item label="兴趣定向">
                                                  <el-radio-group v-model="iitem.isShowType.xingqu_type" @change="changeStartUp($event,iindex)">
                                                    <el-radio-button label="CLOSE">关闭</el-radio-button>
                                                    <el-radio-button label="OPEN">自定义</el-radio-button>
                                                    <el-radio-button label="YOUXUAN">优选定向</el-radio-button>
                                                  </el-radio-group>
                                                </el-form-item>
                                                <el-form-item v-if="iitem.isShowType.xingqu_type == 'YOUXUAN'">
                                                  <el-cascader
                                                    :props="propy"
                                                    v-model="iitem.isShowType.threeLevel"
                                                    :options="options.startUp_options"
                                                  ></el-cascader>
                                                </el-form-item>
                                                <el-form-item v-if="iitem.isShowType.xingqu_type == 'OPEN'">
                                                  <el-collapse accordion @change="changevideoId">
                                                    <el-collapse-item title="APP兴趣" name="1">
                                                      <el-cascader-panel
                                                        :props="propp"
                                                        :options="options.app_category_options"
                                                        v-model="iitem.app_category"
                                                      ></el-cascader-panel>
                                                    </el-collapse-item>
                                                    <el-collapse-item title="商业兴趣" name="2">
                                                      <el-cascader-panel
                                                        :props="propp"
                                                        :options="options.business_interest_options"
                                                        v-model="iitem.business_interest"
                                                      ></el-cascader-panel>
                                                    </el-collapse-item>
                                                    <el-collapse-item title="视频关键词" name="3">
                                                      <p>
                                                        <el-radio-group v-model="iitem.tag.is_fuzzy_tags">
                                                          <el-radio-button label="0">精确匹配</el-radio-button>
                                                          <el-radio-button label="1">模糊匹配</el-radio-button>
                                                        </el-radio-group>
                                                      </p>
                                                      <template v-if="iitem.tag.is_fuzzy_tags == 0">
                                                      <p style="margin-top:10px">
                                                        <el-tag
                                                          :key="tag"
                                                          v-for="tag in iitem.tag.tags"
                                                          closable
                                                          effect="plain"
                                                          type="danger"
                                                          size="small"
                                                          style="margin-left:5px"
                                                          :disable-transitions="false"
                                                          @close="handleCloseAdgroup(tag,iindex)"
                                                        >{{tag}}</el-tag>
                                                        <el-input
                                                          class="input-new-tag"
                                                          v-if="iitem.isShowType.inputVisibleAdgroup"
                                                          v-model="iitem.isShowType.inputValueAdgroup"
                                                          :ref="'saveTagInputAdgroup'+iindex"
                                                          style="width:50px;margin-left:5px"
                                                          size="mini"
                                                          @keyup.enter.native="handleInputConfirmAdgroup(iindex)"
                                                          @blur="handleInputConfirmAdgroup(iindex)"
                                                        ></el-input>
                                                        <el-button
                                                          v-else
                                                          style="margin-left:5px"
                                                          class="button-new-tag"
                                                          size="mini"
                                                          @click="showInputAdgroup(iindex)"
                                                        >+添加</el-button>
                                                      </p>
                                                    </template>
                                                    </el-collapse-item>
                                                    <el-collapse-item title="视频分区兴趣" name="4">
                                                      <el-cascader-panel
                                                        :props="{ emitPath: false, multiple: true,value: 'id',label: 'name'}"
                                                        :options="options.second_options"
                                                        v-model="iitem.archive_content.video_second_partition"
                                                      ></el-cascader-panel>
                                                    </el-collapse-item>
                                                  </el-collapse>
                                                </el-form-item>

                                                <el-form-item label="视频分区">
                                                  <el-radio-group v-model="iitem.isShowType.video_type" @change="getvideos">
                                                    <el-radio-button label="CLOSE">关闭</el-radio-button>
                                                    <el-radio-button label="OPEN">开启</el-radio-button>
                                                  </el-radio-group>
                                                </el-form-item>
                                                <el-form-item v-if="iitem.isShowType.video_type == 'OPEN'">
                                                  <el-checkbox-group v-model="iitem.video_partition">
                                                    <el-checkbox
                                                      v-for="(it,ix) in options.seconddd_options"
                                                      :key="ix"
                                                      :label="it.id"
                                                    >{{ it.name}}</el-checkbox>
                                                  </el-checkbox-group>
                                                </el-form-item>

                                                <el-form-item label="粉丝关系">
                                                  <el-radio-group v-model="iitem.isShowType.up_type" @change="changeSecondId($event,iindex)">
                                                    <el-radio-button label="CLOSE">关闭</el-radio-button>
                                                    <el-radio-button label="OPEN">开启</el-radio-button>
                                                  </el-radio-group>
                                                </el-form-item>
                                                <el-form-item v-if="iitem.isShowType.up_type == 'OPEN'">
                                                  <el-select
                                                    @change="upInfoTo($event,'mid','delUp_options',iindex)"
                                                    clearable
                                                    v-model="iitem.archive_content.include_theirs_fans"
                                                    multiple
                                                    placeholder="包含关注UP主的粉丝"
                                                  >
                                                    <el-option
                                                      v-for="item in iitem.isShowType.inUp_options"
                                                      :key="item.mid"
                                                      :disabled="item.disabled"
                                                      :label="item.name"
                                                      :value="item.mid"
                                                    ></el-option>
                                                  </el-select>
                                                  <el-select
                                                    style="margin-left:20px"
                                                    @change="upInfoTo($event,'mid','inUp_options',iindex)"
                                                    clearable
                                                    v-model="iitem.archive_content.exclude_theirs_fans"
                                                    multiple
                                                    placeholder="排除关注UP主的粉丝"
                                                  >
                                                    <el-option
                                                      v-for="item in iitem.isShowType.delUp_options"
                                                      :key="item.mid"
                                                      :disabled="item.disabled"
                                                      :label="item.name"
                                                      :value="item.mid"
                                                    ></el-option>
                                                  </el-select>
                                                </el-form-item>

                                                <el-form-item label="网络定向">
                                                  <el-radio-group v-model="iitem.isShowType.wifi_type">
                                                    <el-radio-button label="CLOSE">关闭</el-radio-button>
                                                    <el-radio-button label="OPEN">开启</el-radio-button>
                                                  </el-radio-group>
                                                </el-form-item>
                                                <el-form-item v-if="iitem.isShowType.wifi_type == 'OPEN'">
                                                  <el-checkbox-group v-model="iitem.network">
                                                    <el-checkbox
                                                      v-for="(it,ix) in options.network_options"
                                                      :key="ix"
                                                      :label="it.id"
                                                    >{{ it.name}}</el-checkbox>
                                                  </el-checkbox-group>
                                                </el-form-item>

                                                <el-form-item label="人群包定向">
                                                  <el-radio-group v-model="iitem.isShowType.crow_type" @change="crowdChange($event,iindex)">
                                                    <el-radio-button label="CLOSE">关闭</el-radio-button>
                                                    <el-radio-button label="OPEN">开启</el-radio-button>
                                                  </el-radio-group>
                                                </el-form-item>
                                                <el-form-item v-if="iitem.isShowType.crow_type == 'OPEN'">
                                                  <el-select
                                                    @change="upInfoTo($event,'id','delpack_options',iindex)"
                                                    clearable
                                                    v-model="iitem.crowd_pack.crowd_pack_ids"
                                                    multiple
                                                    placeholder="包含的人群包信息"
                                                  >
                                                    <el-option
                                                      v-for="item in iitem.isShowType.inpack_options"
                                                      :key="item.id"
                                                      :disabled="item.disabled"
                                                      :label="item.name"
                                                      :value="item.id"
                                                    ></el-option>
                                                  </el-select>
                                                  <el-select
                                                    style="margin-left:20px"
                                                    @change="upInfoTo($event,'id','inpack_options',iindex)"
                                                    clearable
                                                    v-model="iitem.crowd_pack.exclude_crowd_pack_ids"
                                                    multiple
                                                    placeholder="排除的人群包信息"
                                                  >
                                                    <el-option
                                                      v-for="item in iitem.isShowType.delpack_options"
                                                      :key="item.id"
                                                      :disabled="item.disabled"
                                                      :label="item.name"
                                                      :value="item.id"
                                                    ></el-option>
                                                  </el-select>
                                                </el-form-item>

                                                <el-form-item label="已转化用户过滤" v-if="batchForm.adgroupForm.sales_type == '12_ocpc'">
                                                  <el-radio-group v-model="iitem.isShowType.filter_type">
                                                    <el-radio-button label="CLOSE">关闭</el-radio-button>
                                                    <el-radio-button label="OPEN">开启</el-radio-button>
                                                  </el-radio-group>
                                                </el-form-item>
                                                <el-form-item v-if="iitem.isShowType.filter_type == 'OPEN'">
                                                  <el-checkbox-group v-model="iitem.converted_user_filter">
                                                    <el-checkbox
                                                      v-for="(it,ix) in options.converted_user_filter_options"
                                                      :key="ix"
                                                      :label="it.id"
                                                    >{{ it.name}}</el-checkbox>
                                                  </el-checkbox-group>
                                                </el-form-item>
                                                <el-form-item label="智能放量" v-if="batchForm.adgroupForm.sales_type == '12_ocpc'">
                                                  <el-radio-group v-model="iitem.isShowType.zhineng_type">
                                                    <el-radio-button label="CLOSE">关闭</el-radio-button>
                                                    <el-radio-button label="OPEN">开启</el-radio-button>
                                                  </el-radio-group>
                                                </el-form-item>
                                                <el-form-item v-if="iitem.isShowType.zhineng_type == 'OPEN'">
                                                  <el-checkbox-group v-model="iitem.intelligent_mass.targets">
                                                    <el-checkbox
                                                      v-for="(it,ix) in options.intelligent_mass_options"
                                                      :key="ix"
                                                      :label="it.id"
                                                    >{{ it.name}}</el-checkbox>
                                                  </el-checkbox-group>
                                                </el-form-item>
                                            </el-tab-pane>
                                        </el-tabs>
                                    </div>
                                </el-card>
                            </el-form>
                        </el-col>
                    </el-row>
                    <el-row type="flex" justify="end" v-if="batchForm.advertiser_id">
                      <el-col :span="6">
                          <el-button @click="drawer = false" size="medium">取 消</el-button>
                          <el-button
                              @click="createAdgroupAll('batchForm')"
                              type="primary"
                              size="medium"
                          >确定</el-button>
                      </el-col>
                  </el-row>
                </div>
            </div>
        </el-drawer>
    </div>
  </template>
<script>
    // 引入公共组件供页面使用
    import BTime from '@/components/BTime.vue'
    export default {
    props: ['info'],
    components: {
        BTime
    },
    data() {
        return {
            propp: {
                multiple: true,
                emitPath: false,
                value: 'id',
                label: 'name'
            },
            propy: {
              value: 'k',
              label: 'v'
            },
            adcreativeLoading:false,
            adgroupLoading:false,
            num:'1',
            sourceLoading:false,
            qualification_type: '',
            selectVideos:[],
            sales_types:[],
            tabIndex:'1',
            size:'mini',
            hover: 'hover',
            loading:false,
            editableTabsValue:'1',
            adgroupTabsValue:'',
            drawer:false,
            drawerLoading:false,
            campaignLoading:false,
            activeName:'adgroup',
            promotion_purpose_type:'',
            dialogAdcreativeVisible:false,
            dialogCampaignVisible:false,
            scheduleTimeVisible:false,
            inputVisible: false,
            dialogTableVisible: false,
            inputValue:'',
            adgroupDataTable: {
              data: [],
              name: '',
              dateTime: [],
              page: 1,
              total: 0,
              pagesize: 15
            },
            contentDataTable: {
              data: [],
              name: '',
              itype: '',
              width: '',
              height: '',
              template: '',
              model: 'VIDEO',
              page: 1,
              total: 0,
              pagesize: 15
            },
            searchForm:{
                name:'',
                dateTime:[]
            },
            batchForm:{
                advertiser_id: '',
                campaignForm: {
                    advertiser_id:'',
                    campaign_name: '',
                    promotion_purpose_type: '',
                    budget_limit_type: 1,
                    budget: 500
                },
                adgroupForm: {
                    advertiser_id:'',
                    campaign_id: '',
                    unit_name: '',
                    app_package_id: '',
                    is_store_direct_launch: '0',
                    game_base_id: '',
                    material_id: '',
                    sid: '',
                    begin_date: '',
                    end_date: '',
                    launch_time: '',
                    frequency_unit: '1',
                    frequency_limit: 0,
                    budget: 500,
                    sales_type: '11_cpm',
                    two_stage_bid: 0,
                    cost_price: 0,
                    ocpc_target: '',
                    ocpc_target_two: '',
                    ocpx_target_two_bid: 0,
                    enable_ocpc: 'false',
                    speed_mode: '1',
                    targets: []
                }
            },
            adcreativeForm: {
              advertiser_id: '',
              unit_id: [],
              adcreative_type: '1',
              customized_imp_url: '',
              customized_click_url: '',
              tags: [],
              scene_ids: [],
              enable_space: '',
              brand_info_id: '',
              space_mid: '',
              advertising_mode: '0',
              prefer_scene: [],
              bilibili_video: {},
              creative_vos: [],
              videos: [],
              videos_images: [],
              images: [],
              creative_monitoring: [
                {
                  type: 3,
                  label: '开播监测链接',
                  url: ''
                },
                {
                  type: 4,
                  label: '播放3s监测链接',
                  url: ''
                },
                {
                  type: 5,
                  label: '播放5s监测链接',
                  url: ''
                }
              ],
              cx_creative_vos: []
            },
            adcreativeDataTable: {
              data: [],
              name: '',
              dateTime: [],
              page: 1,
              total: 0,
              pagesize: 15
            },
            getUrl: {
                edit_adgroup: 'pyadver/editAdgroup',
                edit_campaign: 'pyadver/editCampaign',
                edit_creative: 'pyadver/editCreative',
                pack_url: 'pyadver/getpacks',
                pages_url: 'pyadver/getpages',
                button_url: 'pyadver/getbuttons',
                category_url: 'pyadver/getcategorys',
                account_url: 'release/getUserAccountIdList',
                launch_url: 'pyadver/getLaunchType',
                target_url: 'pyadver/getTargetUrl',
                salas_url: 'pyadver/getSalasUrl',
                app_url: 'pyadver/getAppId',
                game_url: 'pyadver/getGameId',
                ad_url: 'pyadver/ad_url',
                brand_url: 'pyadver/getbrandId',
                space_url: 'pyadver/getspaceId',
                second_url: 'pyadver/getSecondId',
                up_url: 'pyadver/getUpId',
                crow_url: 'pyadver/getCrowId',
                starUp_url: 'pyadver/getStarUpId',
                archives_url: 'pyadver/getarchivesId',
                camAdgroup_url: 'pyadver/createCamAdgroup',
                campaign_url: 'pyadver/createCampaign',
                campaign_update_url: 'pyadver/updateCampaign',
                campaignList_url: 'pyadver/getCampaignList',
                adgroupList_url: 'pyadver/getAdgroupList',
                adcreativeList_url: 'pyadver/getAdcreativeList',
                getCampaigns_url: 'pyadver/getCampaigns',
                getAdgroups_url: 'pyadver/getAdgroups',
                adcreative_url: 'pyadver/createAdcreative',
                adcreative_update_url: 'pyadver/updateAdcreative',
                adgroup_url: 'pyadver/createAdgroup',
                adgroup_update_url: 'pyadver/updateAdgroup',
                refersh_url: 'pyadver/refresh',
                zhan_url: 'pyadver/getzhanList',
                scene_url: 'pyadver/getsceneId',
                edit_budget: 'pyadver/editBudget',
                edit_status: 'pyadver/editStatus',
                view_creative: 'pyadver/viewCreative',
                message_creative: 'pyadver/msgCreative'
            },
            // 下拉数据
            options: {
                app_category_options: [],
                business_interest_options: [],
                pp_options: [
                {
                    label: '资质ID',
                    value: '1'
                },
                {
                    label: '资质包',
                    value: '2'
                }
                ],
                targets_options: {},
                page_options: [],
                pack_options: [],
                zhan_options: [],
                template_options: [],
                marks_options: [],
                buttons_options: [],
                category_options: [],
                enable_options: [
                {
                    label: '是',
                    value: '1'
                },
                {
                    label: '否',
                    value: '0'
                }
                ],
                inpack_options: [],
                delpack_options: [],
                startUp_options: [],
                inCrow_options: [],
                delCrow_options: [],
                spaceOptions: [],
                second_options: [],
                seconddd_options: [],
                brandOptions: [],
                adOptions: [],
                gameOptions: [],
                appOptions: [],
                salasOptions: [],
                launchTypes: [],
                accounts: [],
                accounts_adcreatives: [],
                accounts_adgroups: [],
                campaign_options: [],
                adgroup_options: [],
                account_options: [],
            },
            rules: {
                advertiser_id: [
                    {
                    required: true,
                    message: '请选择投放账户',
                    trigger: 'change'
                    }
                ],
                campaignForm:{
                    campaign_name: [
                        {
                        required: true,
                        message: '请输入计划名称',
                        trigger: 'blur'
                        }
                    ],
                },
                adgroupForm:{
                    unit_name: [
                        {
                        required: true,
                        message: '请输入单元名称',
                        trigger: 'blur'
                        }
                    ],
                    app_package_id: [
                        {
                        required: true,
                        message: '请选择appId',
                        trigger: 'blur'
                        }
                    ],
                    game_base_id: [
                        {
                        validator: function(rule, value, callback) {
                            if (!value && this.promotion_purpose_type == 6) {
                            callback(new Error('请选择游戏包'))
                            }
                            callback()
                        }.bind(this),
                        trigger: 'change'
                        }
                    ],
                    begin_date: [
                        {
                        required: true,
                        message: '请选择开始时间',
                        trigger: 'change'
                        }
                    ],
                    launch_time: [
                        {
                        required: true,
                        message: '请选择投放时段',
                        trigger: 'change'
                        }
                    ],
                    budget: [
                        {
                        required: true,
                        message: '请填写预算',
                        trigger: 'change'
                        }
                    ],
                    two_stage_bid: [
                        {
                        required: true,
                        message: '请填写预算',
                        trigger: 'change'
                        }
                    ],
                    cost_price: [
                        {
                        required: true,
                        message: '请选择投放时段',
                        trigger: 'change'
                        }
                    ],
                },
                adcreative: {
                
                    scene_ids: [
                        {
                        type: 'array',
                        required: true,
                        message: '请选择场景',
                        trigger: 'change'
                        }
                    ],
                    unit_id: [
                        {
                        required: true,
                        message: '请选择单元',
                        trigger: 'change'
                        }
                    ],
                    customized_imp_url: [
                        {
                        type: 'url',
                        required: true,
                        message: '请填写展示监控链接',
                        trigger: 'change'
                        }
                    ],
                    customized_click_url: [
                        {
                        type: 'url',
                        required: true,
                        message: '请填写点击监控链接',
                        trigger: 'change'
                        }
                    ],
                    enable_space: [
                        {
                        required: true,
                        message: '请选择是否开启开放空间',
                        trigger: 'change'
                        }
                    ],
                    brand_info_id: [
                        {
                        required: true,
                        message: '请选择品牌信息',
                        trigger: 'change'
                        }
                    ],
                  
                    space_mid: [
                        {
                        required: true,
                        message: '请选择开放空间',
                        trigger: 'change'
                        }
                    ],
                    tags: [
                        {
                        required: true,
                        validator: (rule, value, callback) => {
                            if (value.length <= 0) {
                            callback(new Error('请至少填写一个创意标签'))
                            }
                            callback()
                        },
                        trigger: 'blur'
                        }
                    ]
                },
            },
            pickerOptions:{
              disabledDate(time) {
                const today = new Date();
                today.setHours(0);
                today.setMinutes(0);
                today.setSeconds(0);
                today.setMilliseconds(0);

                return time < today;
              },
            }
        }
    },
    computed: {
      dynamicClasses() {
        return (index) => {
          let num = this.num
          return (index+1) % num === 0 ? 'material-info material-info-border' : 'material-info'
        }
      }
    },
    watch: {
      'adcreativeForm.adcreative_type':{
        immediate: true,
        handler(newValue, oldValue) {
          return newValue == '1' ? this.num = '1' : this.num = '2'
        }
      },
      'contentDataTable.data': {
        deep: true,
        handler(newValue, oldValue) {
         
          newValue.forEach((item, i) => {
            let index = ''
            if (item.type == 'VIDEO') {
              index = this.selectVideos.findIndex(it => {
                if (it.type == 'VIDEO' && it.ugc) {
                  return it.ugc.cid == item.ugc.cid
                }
              })
            } else if (item.type == 'IMAGE') {
              index = this.selectVideos.findIndex(it => {
                if (it.type == 'IMAGE') {
                  return it.id == item.id
                }
              })
            }
            
            if (item.display && index == -1) {
              item['template'] = this.contentDataTable.template
              this.selectVideos.push(item)
            }
            if (!item.display && index != -1) {
              this.selectVideos.splice(index, 1)
            }
          })
        }
      },
      activeName: {
          immediate: true,
          handler(newValue, oldValue) {
            if (newValue == 'adgroup') {
              this.handleCurrentChangeAdgroup(1)
            } else if (newValue == 'adcreative') {
              this.handleCurrentChangeAdcreative(1)
            }
          }
      },
      'batchForm.advertiser_id'(newValue, oldValue) {
          this.batchForm.campaignForm.advertiser_id = newValue
          this.batchForm.adgroupForm.advertiser_id = newValue
      }
    }, 
    methods:{
      changeMedia: function() {
        this.$emit('update:media', '')
        this.$emit('update:dialogMediaVisible', true)
      },
      noMessage: function(advertiser_id, creative_id) {
        this.$api.get(
          this.getUrl.message_creative,
          {
            advertiser_id: advertiser_id,
            creative_id: creative_id
          },
          res => {
            if (res.code == 0) {
              this.$alert(res.msg, '审核信息', {
                confirmButtonText: '确定'
              })
            }
          }
        )
      },
      createAdcreative: function(formName){
        this.$refs[formName].validate(valid => {
          if (valid) {
            this.adcreativeLoading = true
            let unit_ids = JSON.parse(JSON.stringify(this.adcreativeForm.unit_id))
            let allData = []
            unit_ids.forEach(function(it,i){
              let tt = JSON.parse(JSON.stringify(this.adcreativeForm))
              if (tt.adcreative_type == '1') {
                tt.unit_id = it
                if(tt.prefer_scene[i]['scene_ids'].length > 0){
                  tt.scene_ids = tt.prefer_scene[i]['scene_ids']
                }
                tt.creative_vos.forEach(function(item, index) {
                  item.bu_first_category_id = item.categorys[0]
                    ? item.categorys[0]
                    : ''
                  item.bu_second_category_id = item.categorys[1]
                    ? item.categorys[1]
                    : ''
                  item.bu_third_category_id = item.categorys[2]
                    ? item.categorys[2]
                    : ''
                  delete item.categorys
                  delete item.arr
                  item.prefer_scene = tt.prefer_scene[i]['prefer_scene']
                })
                var publicindex = ''
                tt.videos.forEach(
                  function(item, index) {
                    item.danmaku_state = item.danmaku_state ? 1 : 0
                    tt.creative_vos[index].bilibili_video = item
                    tt.creative_vos[index].images.push(tt.videos_images[index])
                    publicindex = index
                  }.bind(this)
                )
                tt.images.forEach(function(item, index) {
                  tt.creative_vos[publicindex + index + 1].images = item
                })
                delete tt.videos
                delete tt.videos_images
                delete tt.images
                delete tt.adcreative_type
                delete tt.cx_creative_vos
                delete tt.creative_monitoring
                delete tt.prefer_scene

                tt.allSource = []
                allData.push(tt)
               

              }else if (tt.adcreative_type == '2') {
                delete tt.creative_vos
                delete tt.videos
                delete tt.videos_images
                delete tt.images
                delete tt.prefer_scene
               
                  tt.cx_creative_vos.forEach(function(item,index){
                    let newtt = JSON.parse(JSON.stringify(item))
                    newtt.media_groups.forEach((itt, i) => {
                        if (itt.bili_video_media_list.length > 0) {
                          itt.bili_video_media_list.forEach((it, ii) => {
                            it.danmaku_state = it.danmaku_state ? 1 : 0
                          })
                        }
                    })
                    
                    newtt.bu_first_category_id = newtt.categorys[0] ? newtt.categorys[0] : ''
                    newtt.bu_second_category_id = newtt.categorys[1] ? newtt.categorys[1] : ''
                    newtt.bu_third_category_id = newtt.categorys[2] ? newtt.categorys[2] : ''
                    delete newtt.categorys
                   
                    newtt.titles.forEach(function(it, i) {
                      if('arr' in it){
                        delete it.arr
                      }
                    })
                    newtt.unit_id = it
                    newtt.advertiser_id = tt.advertiser_id
                    newtt.brand_info_id = tt.brand_info_id
                    newtt.tags = tt.tags
                    newtt.advertising_mode = tt.advertising_mode
                    newtt.space_mid = tt.space_mid
                    newtt.qualification_ids = tt.qualification_ids
                    newtt.customized_imp_url = tt.customized_imp_url
                    newtt.customized_click_url = tt.customized_click_url
                    
                    tt.creative_monitoring.forEach(mm => {
                      if('label' in mm){
                        delete mm.label
                      }
                    })
                    newtt.creative_monitoring = tt.creative_monitoring
                   
                    newtt.allSource = []
                    allData.push(newtt)
                  }.bind(this))
              }
            }.bind(this))
          
            this.$api.post(this.getUrl.adcreative_url, allData, res => {
              if (res.code == '0') {
                this.handleCurrentChangeAdcreative(1)
                this.dialogAdcreativeVisible = false
              } else {
                this.$message.error(res.msg)
              }
              this.adcreativeLoading = false
            })
          }
        })
      },
      delTitles: function(index,ii) {
        this.adcreativeForm.cx_creative_vos[index].titles.splice(index, 1)
      },
      addTitles: function(index) {
        if (this.adcreativeForm.cx_creative_vos[index].titles.length < 6) {
          this.adcreativeForm.cx_creative_vos[index].titles.push({
            title: '',
            area: '',
            gender: '',
            device: '',
            age: '',
            arr: []
          })
        } else {
          this.$message.error('最多可以添加6个标题')
        }
      },
      validateTitles: (rule, value, callback) => {
        if (value.length < 2) {
          callback(new Error('请填写标题，至少需要两个标题'))
        }
        var error = []
        value.forEach((item, index) => {
          if (!item.title) {
            error.push(1)
          }
        })
        if (error.length > 0) {
          callback(new Error('请补全标题，标题不能为空'))
        }
        callback()
      },
      remoteMethodPages: function(query) {
        this.getPublicSelectInfo(this.getUrl.pages_url, 'page_options', {
          account_id: this.adcreativeForm['advertiser_id'],
          name: query ? query : ''
        })
      },
      remoteMethodPackage: function(query) {
        this.getPublicSelectInfo(this.getUrl.pack_url, 'pack_options', {
          account_id: this.adcreativeForm['advertiser_id'],
          name: query ? query : ''
        })
      },
      changePacks: function(val) {
        if (val == '1') {
          this.remoteMethodPages()
        } else if (val == '2') {
          this.remoteMethodPackage()
        }
      },
      allSelect: function(type) {
        this.contentDataTable.data.forEach((item, index) => {
          this.$set(this.contentDataTable.data[index], 'display', type)
        })
      },
      handleInputConfirm: function() {
        let inputValue = this.inputValue
        if (inputValue && this.adcreativeForm.tags.indexOf(inputValue) == -1) {
          this.adcreativeForm.tags.push(inputValue)
        }
        this.inputVisible = false
        this.inputValue = ''
      },
      handleClose: function(tag) {
        this.adcreativeForm.tags.splice(this.adcreativeForm.tags.indexOf(tag), 1)
      },
      returnVideoTags: function(tags) {
        return tags.length > 0 ? tags.join() : '暂无'
      },
      changeBlibliVideo: function(page) {
        // 获取内容专用
        if (this.adcreativeForm.advertiser_id) {
          this.options.template_options.forEach(
            function(item, index) {
              if (
                item.simple_template_group.id == this.contentDataTable.template
              ) {
                if (this.contentDataTable.model == 'VIDEO') {
                  this.contentDataTable.width =
                    item.simple_template_group.video_ratio_width
                  this.contentDataTable.height =
                    item.simple_template_group.video_ratio_height
                }
                if (this.contentDataTable.model == 'IMAGE') {
                  this.contentDataTable.width =
                    item.simple_template_group.image_ratio_width
                  this.contentDataTable.height =
                    item.simple_template_group.image_ratio_height
                  if (item.simple_template_group.id == 2) {
                    this.contentDataTable.itype = 2
                  } else {
                    this.contentDataTable.itype = 1
                  }
                }
              }
            }.bind(this)
          )
          this.sourceLoading = true

          // 请求接口
          this.$api.get(
            this.getUrl.archives_url,
            {
              account_id: this.adcreativeForm.advertiser_id,
              name: this.contentDataTable.name,
              itype: this.contentDataTable.itype,
              width: this.contentDataTable.width,
              height: this.contentDataTable.height,
              model: this.contentDataTable.model,
              page: page ? page : this.contentDataTable.page,
              pagesize: this.contentDataTable.pagesize
            },
            res => {
              if (res.code == '0') {
                res.data.data.forEach(item => {
                  let index = ''
                  if (item.type == 'VIDEO') {
                    index = this.selectVideos.findIndex(it => {
                      if (it.type == 'VIDEO' && it.ugc) {
                        return it.ugc.cid == item.ugc.cid
                      }
                    })
                  } else if (item.type == 'IMAGE') {
                    index = this.selectVideos.findIndex(it => {
                      if (it.type == 'IMAGE') {
                        return it.id == item.id
                      }
                    })
                  }
                  if (index != -1) {
                    item.display = true
                  } else {
                    item.display = false
                  }
                })
                this.contentDataTable.data = res.data.data
                this.contentDataTable.page = res.data.page
                this.contentDataTable.total = res.data.total
                this.contentDataTable.pagesize = res.data.pagesize
              } else {
                this.$message.error(res.msg)
              }
              this.sourceLoading = false
            }
          )
        }
      },
      initSource: function(type) {
        if(this.selectVideos.length <= 0){
          this.$message.error('至少选择一个稿件')
          return
        }
        
        if (this.adcreativeForm.adcreative_type == '1') {
          let v_arr = []
          let vi_arr = []
          let i_arr = []
          let arr = []

          this.selectVideos.forEach((item, index) => {
            if (item.type == 'VIDEO') {
              v_arr.push({
                mid: item.ugc.mid,
                av_id: item.ugc.avid,
                cid: item.ugc.cid,
                cover_url: item.cover.url,
                cover_md5: item.cover.md5,
                width: item.video.width,
                height: item.video.height,
                duration: item.video.duration,
                danmaku_state: item.value,
                reply_state: 0
              })
              vi_arr.push({
                image_url: item.cover.url,
                image_md5: item.cover.md5
              })
            }
            if (item.type == 'IMAGE') {
              i_arr.push({
                image_url: item.mediaUrl,
                id: item.id
              })
            }
            if (!type || type != 'update') {
              arr.push({
                creative_name: '',
                title: '',
                description: '',
                ext_description: '',
                title_link: '',
                title_link_name: '',
                desc_wildcard: {
                  age: '',
                  area: '',
                  device: '',
                  gender: ''
                },
                bu_first_category_id: '',
                bu_second_category_id: '',
                bu_third_category_id: '',
                attach_type: '0',
                button_copy_id: '',
                button_copy_url: '',
                forward_state: '1',
                prefer_scene: [],
                promotion_purpose_content: '',
                jump_type: '1',
                refresh_type: '',
                reply_state: '1',
                share_state: '0',
                template_group_id: item.template,
                qualification_ids: [],
                qualification_package_id: '',
                images: [],
                arr: [],
                categorys: []
              })
            }
          })
          this.adcreativeForm.videos = v_arr
          this.adcreativeForm.videos_images = vi_arr
          this.adcreativeForm.images = i_arr
          if (!type || type != 'update') {
            this.adcreativeForm.creative_vos = arr
          }
        } else if (this.adcreativeForm.adcreative_type == '2') {

          let result = []
          for(let i = 0; i < this.selectVideos.length; i += this.num) {
            let temp = this.selectVideos.slice(i, i + this.num);
            if(temp.length > 0){
              result.push(temp);
            }
          }
          let newResult = []
          result.forEach(innerArr => {
            let v_arr = {}
            innerArr.forEach((item, index) => {
              if (item.type == 'VIDEO') {
                if (!v_arr[item.template]) {
                  v_arr[item.template] = {}
                  v_arr[item.template]['type'] = item.type
                  v_arr[item.template]['sources'] = []
                }
                v_arr[item.template]['sources'].push({
                  mid: item.ugc.mid,
                  av_id: item.ugc.avid,
                  cid: item.ugc.cid,
                  video_cover: {
                    url: item.cover.url,
                    md5: item.cover.md5
                  },
                  danmaku_state: item.value,
                  reply_state: 0
                })
              }
              if (item.type == 'IMAGE') {
                if (!v_arr[item.template]) {
                  v_arr[item.template] = {}
                  v_arr[item.template]['type'] = item.type
                  v_arr[item.template]['sources'] = []
                }
                v_arr[item.template]['sources'].push({
                  url: item.mediaUrl,
                  md5: item.mediaMd5,
                  mgk_media_id: item.mediaId
                })
              }
            })
            newResult.push(v_arr)
          })
          let aaa = []
          newResult.forEach((item,index)=>{
            for (let key in item) {
              let info = {
                titles: [
                  {
                    title: '',
                    area: '',
                    gender: '',
                    device: '',
                    age: '',
                    arr: []
                  },
                  {
                    title: '',
                    area: '',
                    gender: '',
                    device: '',
                    age: '',
                    arr: []
                  },
                  {
                    title: '',
                    area: '',
                    gender: '',
                    device: '',
                    age: '',
                    arr: []
                  }
                ],
                description: '',
                ext_description: '',
                media_groups: [],
                categorys: [],
                bu_first_category_id: '',
                bu_second_category_id: '',
                bu_third_category_id: '',
                jump_type: '',
                promotion_purpose_content: '',
                qualification_ids: [],
                qualification_package_id: ''
              }
              if(item[key]['type'] == 'VIDEO'){
                info.media_groups.push({
                  template_group_id: key,
                  bili_video_media_list: item[key]['sources']
                })
              }
              if(item[key]['type'] == 'IMAGE'){
                info.media_groups.push({
                  template_group_id: key,
                  monoMediaList: item[key]['sources']
                })
              }
              aaa.push(info)
            }
          })
          this.$set(this.adcreativeForm,'cx_creative_vos',aaa)
        }
        this.getPublicSelectInfo(this.getUrl.category_url, 'category_options', {
            account_id: this.adcreativeForm.advertiser_id
        })
        this.dialogTableVisible = false
      },
      templateChange: function(val) {
        let index = this.options.template_options.findIndex(it => {
          return it.simple_template_group.id == val
        })
        let type = this.options.template_options[index].simple_template_group
          .tg_type
        if (type == 2) {
          this.contentDataTable.model = 'VIDEO'
        } else {
          this.contentDataTable.model = 'IMAGE'
        }
        this.changeBlibliVideo(1)
      },
      changeEnable: function(val) {
        if (this.adcreativeForm['advertiser_id'] && val == 0) {
          this.getPublicSelectInfo(this.getUrl.brand_url, 'brandOptions', {
            account_id: this.adcreativeForm['advertiser_id']
          })
        } else if (this.adcreativeForm['advertiser_id'] && val == 1) {
          this.getPublicSelectInfo(this.getUrl.space_url, 'spaceOptions', {
            account_id: this.adcreativeForm['advertiser_id']
          })
        } else {
          this.$message.error('请先勾选账户')
        }
      },
      showInput: function() {
        this.inputVisible = true
        this.$nextTick(_ => {
          this.$refs.saveTagInput.$refs.input.focus()
        })
      },
      changeSience: function(val, index) {
        if (val == '0') {
          this.$api.get(this.getUrl.scene_url, {
            account_id: this.adcreativeForm['advertiser_id'],
            unit_id: this.adcreativeForm.unit_id[index]
          }, res => {
            if (res.code == '0') {
              this.adcreativeForm.prefer_scene[index].sceneOptions = res.data
            } else {
              this.$message.error(res.msg)
            }
          })
        }
      },
      changeAdgroup(vals) {
        if (vals.length > 0) {
          let newVals = []
          let newAdgroups = []
          this.adcreativeForm.prefer_scene = []
          this.options.adgroup_options.forEach((item, index) => {
            if (vals.indexOf(item.adgroup_id) !== -1) {
              newVals.push(item.sales_type)
              newAdgroups.push(item.promotion_purpose_type)
              this.promotion_purpose_type = item.promotion_purpose_type
            }
          })
          
          // 去重
          if(Array.from(new Set(newVals)).length > 1){
            this.$message.error('必须选择相同售卖类型的单元')
            this.adcreativeForm.unit_id = []
          }else if(Array.from(new Set(newAdgroups)).length > 1){
            this.$message.error('必须选择相同计划下的单元')
            this.adcreativeForm.unit_id = []
          }else{
            this.adgroupTabsValue = vals[0]
            newVals.forEach(function(item, index){
              this.adcreativeForm.prefer_scene.push({
                'prefer_scene':'1',
                'scene_ids':[],
                'sceneOptions': [],
              })
            }.bind(this))                  
          }
          this.sales_types = newVals[0]
        }
      },
      remoteAdgroup(val) {
        this.getPublicSelectInfo(this.getUrl.getAdgroups_url, 'adgroup_options', {
          query: val
        })
      },
      changeAccountAdcreative(val) {
        if (val) {
          this.getPublicSelectInfo(
            this.getUrl.getAdgroups_url,
            'adgroup_options',
            {
              account_id: val
            }
          )
        }
      },
      remoteAccountAdcreative(val) {
        this.getPublicSelectInfo(
          this.getUrl.account_url,
          'accounts_adcreatives',
          {
            query: val
          }
        )
      },
      returnVideoUrl(url) {
        return url.replace('https://i0', 'https://p0')
      },
      openAdcreativeDrawer() {
        this.dialogAdcreativeVisible = true
        this.getPublicSelectInfo(this.getUrl.account_url, 'accounts_adcreatives')
      },
      // 创意列表
      handleCurrentChangeAdcreative(page) {
        let ff = {
          ...this.adcreativeDataTable
        }
        delete ff['data']
        delete ff['total']
        ff['page'] = page ? page : ff['page']
        this.$api.get(this.getUrl.adcreativeList_url, ff, res => {
          if (res.code == '0') {
            this.adcreativeDataTable.data = res.data.data
            this.adcreativeDataTable.page = res.data.page
            this.adcreativeDataTable.total = res.data.total
            this.adcreativeDataTable.pagesize = res.data.pagesize
          } else {
            this.$message.error(res.msg)
          }
        })
      },
      returnInitTime(arr) {
          if (arr.length > 0) {
            var newarr = []
            arr.forEach(item => {
              newarr.push(`${item}时`)
            })
            return `${newarr}`
          } else {
            return '暂无投放时段'
          }
      },
      // 单元列表
      handleCurrentChangeAdgroup(page) {
        let ff = {
          ...this.adgroupDataTable
        }
        delete ff['data']
        delete ff['total']
        ff['page'] = page ? page : ff['page']
        this.$api.get(this.getUrl.adgroupList_url, ff, res => {
          if (res.code == '0') {
            this.adgroupDataTable.data = res.data.data
            this.adgroupDataTable.page = res.data.page
            this.adgroupDataTable.total = res.data.total
            this.adgroupDataTable.pagesize = res.data.pagesize
          } else {
            this.$message.error(res.msg)
          }
        })
      },
      // 创建计划
      createCampaign(callback) {
        this.$api.post(this.getUrl.campaign_url, this.batchForm.campaignForm, res => {
          if (res.code == '0') {
            callback(res.data)
          } else {
            this.$message.error(res.msg)
            return
          }
        })
      }, 
      createAdgroupAll(formName){
        //  验证表单
        this.$refs[formName].validate(valid => {
          if (valid) {
            this.adgroupLoading = true
            this.createCampaign((res) => {
                let targets = JSON.parse(JSON.stringify(this.batchForm.adgroupForm.targets))
                let allData = []
                targets.forEach(function(targetData,index){
                  let adgroups = JSON.parse(JSON.stringify(this.batchForm.adgroupForm))
                  adgroups.frequency_limit = adgroups.frequency_limit == 0 ? '' : adgroups.frequency_limit
                  let isShowType = targetData.isShowType
                  delete targetData['name']
                  delete targetData['isShowType']
                  adgroups.campaign_id = res.id
                  adgroups.unit_name = adgroups.unit_name+'_'+(index+1)
                  if (isShowType.age_type == 'CLOSE') {
                    delete targetData.age
                  }
                  if (isShowType.gender_type == 'CLOSE') {
                    delete targetData.gender
                  }
                  if (isShowType.area_type == 'CLOSE') {
                    delete targetData.area
                  }
                  if (isShowType.os_type == 'CLOSE') {
                    delete targetData.os
                  }
                  if (isShowType.brand_type == 'CLOSE') {
                    delete targetData.device_brand
                  }
                  if (isShowType.xingqu_type == 'CLOSE') {
                    delete targetData.app_category
                    delete targetData.business_interest
                    delete targetData.tag
                    delete targetData.archive_content.video_second_partition
                    delete targetData.start_up_crowd
                  }
                  if (isShowType.xingqu_type == 'OPEN') {
                    delete targetData.start_up_crowd
                  }
                  if (isShowType.xingqu_type == 'YOUXUAN') {
                    delete targetData.app_category
                    delete targetData.business_interest
                    delete targetData.tag
                    delete targetData.archive_content.video_second_partition
                  }
                  if (isShowType.wifi_type == 'CLOSE') {
                    delete targetData.network
                  }
                  if (isShowType.filter_type == 'CLOSE') {
                    delete targetData.converted_user_filter
                  }
                  if (isShowType.video_type == 'CLOSE') {
                    delete targetData.video_partition
                  }
                  if (isShowType.up_type == 'CLOSE') {
                    delete targetData.archive_content.include_theirs_fans
                    delete targetData.archive_content.exclude_theirs_fans
                  }
                  // if (this.crow_type == 'CLOSE') {
                  //   delete tt.targets.crowd_pack
                  // }
                  if (isShowType.zhineng_type == 'CLOSE') {
                    delete targetData.intelligent_mass
                  }
                  if (JSON.stringify(targetData.archive_content) == '{}') {
                    delete targetData.archive_content
                  }
                  if (this.batchForm.campaignForm.promotion_purpose_type == 2) {
                    delete adgroups['unit_promotion_purpose_type']
                    delete adgroups['material_id']
                    delete adgroups['sid']
                    delete adgroups['is_store_direct_launch']
                    delete adgroups['game_base_id']
                  } else if (this.promotion_purpose_type == 4) {
                    delete adgroups['material_id']
                    delete adgroups['sid']
                    delete adgroups['game_base_id']
                  } else if (this.promotion_purpose_type == 6) {
                    delete adgroups['unit_promotion_purpose_type']
                    delete adgroups['material_id']
                    delete adgroups['sid']
                    delete adgroups['is_store_direct_launch']
                    delete adgroups['app_package_id']
                  } else if (this.promotion_purpose_type == 8) {
                    delete adgroups['unit_promotion_purpose_type']
                    delete adgroups['sid']
                    delete adgroups['is_store_direct_launch']
                    delete adgroups['game_base_id']
                    delete adgroups['app_package_id']
                  } else if (this.promotion_purpose_type == 15) {
                    delete adgroups['material_id']
                    delete adgroups['sid']
                    delete adgroups['is_store_direct_launch']
                    delete adgroups['game_base_id']
                    delete adgroups['app_package_id']
                  }
                  adgroups['targets'] = targetData
                  allData.push(adgroups)
                }.bind(this))
                this.$api.post(this.getUrl.adgroup_url, allData, res => {
                  if (res.code == '0') {
                    this.handleCurrentChangeAdgroup(1)
                    this.drawer = false
                  } else {
                    this.$message.error(res.msg)
                  }
                  this.adgroupLoading = false
                })
                
            })
          }
        })
      },
      changepage: function(val) {
        if (val == '5') {
          this.getPublicSelectInfo(this.getUrl.zhan_url, 'zhan_options', {
            account_id: this.adcreativeForm['advertiser_id'],
            promotion_purpose_type: this.promotion_purpose_type
          })
        }
      },
      createAdgroup: function(targetData,campaign_id,index) {
          let adgroups = JSON.parse(JSON.stringify(this.batchForm.adgroupForm))
          adgroups.frequency_limit = adgroups.frequency_limit == 0 ? '' : adgroups.frequency_limit
          let isShowType = targetData.isShowType
          delete targetData['name']
          delete targetData['isShowType']
          adgroups.campaign_id = campaign_id
          adgroups.unit_name = adgroups.unit_name+'_'+(index+1)
          if (isShowType.age_type == 'CLOSE') {
            delete targetData.age
          }
          if (isShowType.gender_type == 'CLOSE') {
            delete targetData.gender
          }
          if (isShowType.area_type == 'CLOSE') {
            delete targetData.area
          }
          if (isShowType.os_type == 'CLOSE') {
            delete targetData.os
          }
          if (isShowType.brand_type == 'CLOSE') {
            delete targetData.device_brand
          }
          if (isShowType.xingqu_type == 'CLOSE') {
            delete targetData.app_category
            delete targetData.business_interest
            delete targetData.tag
            delete targetData.archive_content.video_second_partition
            delete targetData.start_up_crowd
          }
          if (isShowType.xingqu_type == 'OPEN') {
            delete targetData.start_up_crowd
          }
          if (isShowType.xingqu_type == 'YOUXUAN') {
            delete targetData.app_category
            delete targetData.business_interest
            delete targetData.tag
            delete targetData.archive_content.video_second_partition
          }
          if (isShowType.wifi_type == 'CLOSE') {
            delete targetData.network
          }
          if (isShowType.filter_type == 'CLOSE') {
            delete targetData.converted_user_filter
          }
          if (isShowType.video_type == 'CLOSE') {
            delete targetData.video_partition
          }
          if (isShowType.up_type == 'CLOSE') {
            delete targetData.archive_content.include_theirs_fans
            delete targetData.archive_content.exclude_theirs_fans
          }
          // if (this.crow_type == 'CLOSE') {
          //   delete tt.targets.crowd_pack
          // }
          if (isShowType.zhineng_type == 'CLOSE') {
            delete targetData.intelligent_mass
          }
          if (JSON.stringify(targetData.archive_content) == '{}') {
            delete targetData.archive_content
          }
          if (this.batchForm.campaignForm.promotion_purpose_type == 2) {
            delete adgroups['unit_promotion_purpose_type']
            delete adgroups['material_id']
            delete adgroups['sid']
            delete adgroups['is_store_direct_launch']
            delete adgroups['game_base_id']
          } else if (this.promotion_purpose_type == 4) {
            delete adgroups['material_id']
            delete adgroups['sid']
            delete adgroups['game_base_id']
          } else if (this.promotion_purpose_type == 6) {
            delete adgroups['unit_promotion_purpose_type']
            delete adgroups['material_id']
            delete adgroups['sid']
            delete adgroups['is_store_direct_launch']
            delete adgroups['app_package_id']
          } else if (this.promotion_purpose_type == 8) {
            delete adgroups['unit_promotion_purpose_type']
            delete adgroups['sid']
            delete adgroups['is_store_direct_launch']
            delete adgroups['game_base_id']
            delete adgroups['app_package_id']
          } else if (this.promotion_purpose_type == 15) {
            delete adgroups['material_id']
            delete adgroups['sid']
            delete adgroups['is_store_direct_launch']
            delete adgroups['game_base_id']
            delete adgroups['app_package_id']
          }
          adgroups['targets'] = targetData
          
          this.$api.post(this.getUrl.adgroup_url, adgroups, res => {
            if (res.code == '0') {
              
            } else {
              this.$message.error(res.msg)
            }
          })
      },
      openbili() {
        
        this.$api.get(
          this.getUrl.button_url,
          {
            account_id: this.adcreativeForm['advertiser_id'],
            unit_id: this.adcreativeForm['unit_id'][0],
            is_prefer_scene: this.adcreativeForm.prefer_scene[0]['prefer_scene'],
            scene_ids: this.adcreativeForm.prefer_scene[0]['scene_ids'],
            is_programmatic: this.adcreativeForm.adcreative_type == '2' ? 1 : 0,
            advertising_mode: this.adcreativeForm.advertising_mode
          },
          res => {
            if (res.code == '0') {
              
              this.options.template_options = res.data
              if (res.data.length > 0){
                this.contentDataTable.template =
                res.data[0].simple_template_group.id
                this.contentDataTable.model =
                  res.data[0].simple_template_group.tg_type == 2 ? 'VIDEO' : 'IMAGE'

                if (this.contentDataTable.model == 'VIDEO') {
                  this.contentDataTable.width =
                    res.data[0].simple_template_group.video_ratio_width
                  this.contentDataTable.height =
                    res.data[0].simple_template_group.video_ratio_height
                }
                if (this.contentDataTable.model == 'IMAGE') {
                  this.contentDataTable.width =
                    res.data[0].simple_template_group.image_ratio_width
                  this.contentDataTable.height =
                    res.data[0].simple_template_group.image_ratio_height
                  if (res.data[0].simple_template_group.id == 2) {
                    this.contentDataTable.itype = 2
                  } else {
                    this.contentDataTable.itype = 1
                  }
                }
                this.dialogTableVisible = true
                this.changeBlibliVideo(1)  
              }
            } else {
              this.$message.error(res.msg)
            }
          }
        )
      },
      creativeChange(val) {
        if (
          val == '2' &&
          (this.adcreativeForm.images.length > 0 ||
            this.adcreativeForm.videos.length > 0)
        ) {
          this.$alert('切换创意类型，会清空所选创意素材', '注意', {
            confirmButtonText: '确定',
            callback: action => {
              this.selectVideos = []
              this.adcreativeForm.images = []
              this.adcreativeForm.videos = []
              this.adcreativeForm.videos_images = []
            }
          })
        } else if (
          val == '1' &&
          this.adcreativeForm.cx_creative_vos.media_groups.length > 0
        ) {
          this.$alert('切换创意类型，会清空所选创意素材', '注意', {
            confirmButtonText: '确定',
            callback: action => {
              this.selectVideos = []
              this.adcreativeForm.cx_creative_vos.media_groups = []
            }
          })
        }
      },
      returnsalasType(type) {
        let data = []
        this.options.salasOptions.forEach(element => {
          if (element.sales_type + '_' + element.name.toLowerCase() == type) {
            data = element.targets
          }
        })
        return data
      },
      crowdChange(val,index){
        if(val == 'OPEN'){
          this.batchForm.adgroupForm.targets[index].isShowType.inpack_options = this.options.inpack_options
          this.batchForm.adgroupForm.targets[index].isShowType.delpack_options = this.options.delpack_options
        }
      },
      upInfoTo(vals, type, fields, index) {
        this.batchForm.adgroupForm.targets[index].isShowType[fields].forEach(function(item) {
          if (vals.indexOf(item[type]) != -1) {
            item.disabled = true
          } else {
            item.disabled = false
          }
        })
      },
      changeSecondId(val,index) {
        if (val == 'OPEN') {
          this.$api.get(
            this.getUrl.up_url,
            {
              account_id: this.batchForm.advertiser_id
            },
            res => {
              if (res.code == '0') {
                let dd = []
                res.data.forEach(function(item) {
                  item['disabled'] = false
                  dd.push(item)
                })
                this.batchForm.adgroupForm.targets[index].isShowType.delUp_options = JSON.parse(JSON.stringify(dd))
                this.batchForm.adgroupForm.targets[index].isShowType.inUp_options = JSON.parse(JSON.stringify(dd))
              }
              this.batchForm.adgroupForm.targets[index].isShowType.up_type = 'OPEN'
            }
          )
        }
      },
      getvideos(val) {
        if (val == 'OPEN') {
          this.getPublicSelectInfo(this.getUrl.second_url, 'seconddd_options', {
            account_id: this.batchForm.advertiser_id
          })
        }
      },
      //  删除tag标签
      handleCloseAdgroup(tag,index) {
        this.batchForm.adgroupForm.targets[index].tag.tags.splice(
          this.batchForm.adgroupForm.targets[index].tag.tags.indexOf(tag),
          1
        )
      },
      //  确认tag标签
      handleInputConfirmAdgroup(index) {
        let inputValue = this.batchForm.adgroupForm.targets[index].isShowType.inputValueAdgroup
        if (
          inputValue &&
          this.batchForm.adgroupForm.targets[index].tag.tags.indexOf(inputValue) == -1
        ) {
          this.batchForm.adgroupForm.targets[index].tag.tags.push(inputValue)
        }
        this.batchForm.adgroupForm.targets[index].isShowType.inputVisibleAdgroup = false
        this.batchForm.adgroupForm.targets[index].isShowType.inputValueAdgroup = ''
      },
      //  展示tag标签
      showInputAdgroup(index) {
        this.batchForm.adgroupForm.targets[index].isShowType.inputVisibleAdgroup = true
        this.$nextTick(_ => {
          this.$refs['saveTagInputAdgroup'+index][0].$refs.input.focus()
        })
      },
      changeVideo: function(type, index, status) {
        if (type == 'add') {
          if (
            this.adcreativeForm.id &&
            this.adcreativeForm.adcreative_type == 1 &&
            this.selectVideos.length >= 1
          ) {
            this.$message.error('修改创意列表只可以有一个稿件')
          } else {
            this.$set(this.contentDataTable.data[index], 'display', !status)
          }
        }
        if (type == 'del') {
          this.selectVideos.splice(index, 1)
          if (status.type == this.contentDataTable.model) {
            let ii = this.contentDataTable.data.findIndex(it => {
              if (status.type == 'VIDEO') {
                return status.ugc.cid == it.ugc.cid
              }
              if (status.type == 'IMAGE') {
                return status.id == it.id
              }
            })
            this.$set(this.contentDataTable.data[ii], 'display', !status)
          }
        }
      },
      clearAll(){
        this.contentDataTable.data.forEach(function(item,index){
          this.$set(this.contentDataTable.data[index], 'display', false)
        }.bind(this))
        this.selectVideos = []
      },
      changevideoId(val) {
          if (val == '4') {
            this.getPublicSelectInfo(this.getUrl.second_url, 'second_options', {
              account_id: this.batchForm.advertiser_id
            })
          }
      },
      changeStartUp(val,index) {
        if (val == 'YOUXUAN') {
          this.getPublicSelectInfo(this.getUrl.starUp_url, 'startUp_options', {
            account_id: this.batchForm.advertiser_id
          })
        }
        this.batchForm.adgroupForm.targets[index]['isShowType']['threeLevel'] = []
        this.batchForm.adgroupForm.targets[index].app_category = ''
        this.batchForm.adgroupForm.targets[index].business_interest = ''
        this.batchForm.adgroupForm.targets[index].tag.is_fuzzy_tags = '0'
        this.batchForm.adgroupForm.targets[index].tag.tags = []
        this.batchForm.adgroupForm.targets[index].archive_content.video_second_partition = []
      },
      handleTabsEdit(targetName, action) {
          if (action === 'add') {
              let newTabName = ++this.tabIndex + '';
              this.batchForm.adgroupForm.targets.push({
                          name:newTabName,
                          isShowType:{
                              inpack_options: [],
                              delpack_options: [],
                              delUp_options: [],
                              inUp_options: [],
                              inputVisibleAdgroup:false,
                              inputValueAdgroup:'',
                              zhineng_type: 'CLOSE',
                              age_type: 'CLOSE',
                              gender_type: 'CLOSE',
                              area_type: 'CLOSE',
                              os_type: 'CLOSE',
                              brand_type: 'CLOSE',
                              xingqu_type: 'CLOSE',
                              wifi_type: 'CLOSE',
                              filter_type: 'CLOSE',
                              video_type: 'CLOSE',
                              up_type: 'CLOSE',
                              crow_type: 'CLOSE',
                              threeLevel: [],
                              sales_type: ''
                          },
                          age: [],
                          gender: [],
                          area: [],
                          os: [],
                          device_brand: [],
                          app_category: [],
                          business_interest: [],
                          tag: {
                              is_fuzzy_tags: '1',
                              tags: []
                          },
                          video_partition: [],
                          archive_content: {
                              video_second_partition: [],
                              include_theirs_fans: [],
                              exclude_theirs_fans: []
                          },
                          crowd_pack: {
                              crowd_pack_ids: [],
                              exclude_crowd_pack_ids: []
                          },
                          start_up_crowd: {
                              level_one_id: '',
                              level_two_id: '',
                              level_three_id: ''
                          },
                          network: [],
                          converted_user_filter: [],
                          intelligent_mass: {
                              targets: []
                          }
                      })
                      this.editableTabsValue = newTabName;
          }
          if (action === 'remove') {
              let tabs = this.batchForm.adgroupForm.targets;
              if(tabs.length <= 1){
                  this.$message.error('至少一个定向')
                  return
              }
              let activeName = this.editableTabsValue;
              
              if (activeName === targetName) {
                  tabs.forEach((tab, index) => {
                      if (tab.name == targetName) {
                          let nextTab = tabs[index + 1] || tabs[index - 1];
                          if (nextTab) {
                              activeName = nextTab.name;
                          }
                      }
                  });
              }
              this.$set(this.batchForm.adgroupForm,'targets', tabs.filter(tab => tab.name != targetName));
              this.editableTabsValue = activeName;
              
          }
      },
      returncost: function(type) {
          if (type == '11_cpm') {
              return 1
          } else if (type == '12_cpc') {
              return 0.5
          } else if (type == '11_ocpc') {
              return 0.5
          }
      },
      editStatus: function(type, status, objIds) {
          this.loading = true
          let ad_ids = objIds.map(item => item.ad_id)
          let ids = objIds.map(item => item.id)
          var requestType = ''
          if (type == 'campaignDataTable') {
              requestType = 'campaign'
          } else if (type == 'adgroupDataTable') {
              requestType = 'adgroup'
          } else {
              requestType = 'adcreative'
          }

          this.$api.post(
              this.getUrl.edit_status,
              {
              advertiser_id: objIds[0]['advertiser_id'],
              ad_ids: ad_ids,
              launch_status: status,
              type: requestType
              },
              res => {
              if (res.code == 0) {
                  this[type].data.forEach((item, index) => {
                  if (ids.indexOf(item.id) != -1) {
                      this.$set(this[type].data[index], 'line_status', status)
                  }
                  })
                  this.$message({
                  type: 'success',
                  message: '您的状态修改成功了'
                  })
              } else {
                  this.$message({
                  type: 'error',
                  message: res.msg
                  })
              }
              this.loading = false
              }
          )
      },
      editBudget: function(type, objIds) {
          this.loading = true
          // 必须是同一个账户下，当前方法只支持同一个账户下
          let ad_ids = objIds.map(item => item.ad_id)
          let ids = objIds.map(item => item.id)
          this.$prompt('请输入修改的预算', '提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              inputValidator: value => {
              // 金额正则,整数或最多两位小数
              const amountRegex = /^(([1-9]\d*)|\d)(\.\d{1,2})?$/

              if (amountRegex.test(value)) {
                  // 转换为数字类型比较大小
                  const amount = Number(value)

                  if (amount >= 500) {
                  return true
                  } else {
                  return '金额不能低于500'
                  }
              } else {
                  return '金额格式不正确'
              }
              }
          })
              .then(({ value }) => {
              this.$api.post(
                  this.getUrl.edit_budget,
                  {
                  advertiser_id: objIds[0]['advertiser_id'],
                  ids: ids,
                  ad_ids: ad_ids,
                  budget: value,
                  type: type == 'campaignDataTable' ? 'campaign' : 'adgroup'
                  },
                  res => {
                  if (res.code == 0) {
                      if(type == 'campaignDataTable'){
                        type = 'adgroupDataTable'
                        this[type].data.forEach((item, index) => {
                          if (ids.indexOf(item.campaign_auto_id) != -1) {
                            this.$set(this[type].data[index], 'campaign_budget', value * 100)
                          }
                        })
                      }else{
                        this[type].data.forEach((item, index) => {
                          if (ids.indexOf(item.id) != -1) {
                              this.$set(this[type].data[index], 'budget', value * 100)
                          }
                        })
                      }
                      
                      this.$message({
                      type: 'success',
                      message: '您的预算金额修改为: ' + value + '元'
                      })
                  } else {
                      this.$message({
                      type: 'error',
                      message: res.msg
                      })
                  }
                  this.loading = false
                  }
              )
              })
              .catch(() => {
              this.$message({
                  type: 'info',
                  message: '取消修改预算'
              })
              this.loading = false
              })
      },
      refresh: function(type, id) {
          this.loading = true
          this.$api.get(
              this.getUrl.refersh_url,
              {
              type: type,
              id: id
              },
              res => {
              if (type == 'adgroup' || type == 'campaign') {
                  this.handleCurrentChangeAdgroup()
              }else if (type == 'adcreative') {
                  this.handleCurrentChangeAdcreative()
              }
              this.loading = false
              if (res.code == '0') {
                  this.$message.success('刷新成功')
              } else {
                  this.$message.error(res.msg)
              }
              }
          )
      },
      // 计划列表
      handleCurrentChangeCampaign: function(page) {
          let ff = {
              ...this.campaignDataTable
          }
          delete ff['data']
          delete ff['total']
          ff['page'] = page ? page : ff['page']
          this.$api.get(this.getUrl.campaignList_url, ff, res => {
              if (res.code == '0') {
              this.campaignDataTable.data = res.data.data
              this.campaignDataTable.page = res.data.page
              this.campaignDataTable.total = res.data.total
              this.campaignDataTable.pagesize = res.data.pagesize
              } else {
              this.$message.error(res.msg)
              }
          })
      },
      // 打开计划弹窗
      openCampaignDrawer() {
          this.getPublicSelectInfo(this.getUrl.account_url, 'accounts')
          this.dialogCampaignVisible = true
      },
      getSalesType: function(val) {
          this.getPublicSelectInfo(this.getUrl.salas_url, 'salasOptions', {
              account_id: this.batchForm.advertiser_id,
              promotion_purpose_type: val
          })
          if (val == 2 || val == 4) {
              // 获取appID
              this.getPublicSelectInfo(this.getUrl.app_url, 'appOptions', {
              account_id: this.batchForm.advertiser_id
              })
          }
          if (val == 6) {
              // 获取直播id
              this.getPublicSelectInfo(this.getUrl.game_url, 'gameOptions', {
              account_id: this.batchForm.advertiser_id
              })
          }
      },
      changeCampaign: function(val) {
          this.options.campaign_options.forEach(item => {
              if (item.campaign_id == val) {
                  this.promotion_purpose_type = item.promotion_purpose_type
              }
          })
          this.getSalesType(this.promotion_purpose_type)
      },
      remoteCampaign: function(val) {
          this.getPublicSelectInfo(
              this.getUrl.getCampaigns_url,
              'campaign_options',
              {
              query: val
              }
          )
      },
      changeAccount: function(val) {
          if (val) {
              this.$api.get(
              this.getUrl.launch_url,
              {
                  account_id: val
              },
              res => {
                  if (res.code == '0') {
                  this.batchForm.campaignForm.promotion_purpose_type = res.data[0].id
                  this.options['launchTypes'] = res.data
                  } else {
                  this.$message.error(res.msg)
                  }
              }
              )
          } else {
              this.batchForm.campaignForm.promotion_purpose_type = []
              this.batchForm.adgroupForm.targets = []
          }
      },
      changeAccountAdgroup(val) {

          if (val) {
              this.changeAccount(val)
              this.getPublicSelectInfo(this.getUrl.getCampaigns_url,'campaign_options',{account_id: val})
              // 获取定向信息
              this.$api.get(this.getUrl.target_url,{account_id: val},
              res => {
                  if (res.code == '0') {
                      let arr = ['inlineSalesType', 'HighPlayArchive', 'time']
                      for (const key in res.data) {
                          if (arr.indexOf(key) == -1) {
                          if (key == 'crowd_pack') {
                              this.options.inpack_options = JSON.parse(
                              JSON.stringify(res.data[key])
                              )
                              this.options.delpack_options = JSON.parse(
                              JSON.stringify(res.data[key])
                              )
                          } else {
                              this.options[key + '_' + 'options'] = JSON.parse(
                              JSON.stringify(res.data[key])
                              )
                          }
                          }
                      }
                      this.$set(this.batchForm.adgroupForm,'targets',[])
                      this.batchForm.adgroupForm.targets.push({
                          name:'1',
                          isShowType:{
                              inpack_options: [],
                              delpack_options: [],
                              delUp_options: [],
                              inUp_options: [],
                              inputVisibleAdgroup:false,
                              inputValueAdgroup:'',
                              zhineng_type: 'CLOSE',
                              age_type: 'CLOSE',
                              gender_type: 'CLOSE',
                              area_type: 'CLOSE',
                              os_type: 'CLOSE',
                              brand_type: 'CLOSE',
                              xingqu_type: 'CLOSE',
                              wifi_type: 'CLOSE',
                              filter_type: 'CLOSE',
                              video_type: 'CLOSE',
                              up_type: 'CLOSE',
                              crow_type: 'CLOSE',
                              threeLevel: [],
                              sales_type: ''
                          },
                          age: [],
                          gender: [],
                          area: [],
                          os: [],
                          device_brand: [],
                          app_category: [],
                          business_interest: [],
                          tag: {
                              is_fuzzy_tags: '1',
                              tags: []
                          },
                          video_partition: [],
                          archive_content: {
                              video_second_partition: [],
                              include_theirs_fans: [],
                              exclude_theirs_fans: []
                          },
                          crowd_pack: {
                              crowd_pack_ids: [],
                              exclude_crowd_pack_ids: []
                          },
                          start_up_crowd: {
                              level_one_id: '',
                              level_two_id: '',
                              level_three_id: ''
                          },
                          network: [],
                          converted_user_filter: [],
                          intelligent_mass: {
                              targets: []
                          }
                      })
                  } else {
                      this.$message.error(res.msg)
                  }
              })
          } else {
              this.options.campaign_options = []
          }
      },
      remoteAccount(val) {
          this.getPublicSelectInfo(this.getUrl.account_url, 'accounts', {
              query: val
          })
      },
      // 公共下拉请求适用于options下拉
      getPublicSelectInfo(url, optionField, query, callback) {
          if (JSON.stringify(query) === '{}') {
              var query = {
              query: ''
              }
          }
          // 请求接口
          this.$api.get(url, query, res => {
              if (res.code == '0') {
                  this.options[optionField] = res.data
              } else {
                  this.$message.error(res.msg)
              }
              if (callback) {
                  callback()
              }
          })
      },
      // 打开批量创建抽屉
      createTemplate(){
          this.drawer = true
          this.getPublicSelectInfo(this.getUrl.account_url, 'accounts')
      },
    },
    }
</script>
<style scoped>
.kImgBox .img {
  width: 120px;
  height: 80px;
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center center;
}

.kImgBoxS {
  display: flex;
  flex-wrap: wrap;
  width: 120px;
}

.kImgBoxS .img {
  width: 58px;
  height: 38px;
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center center;
}

.kImgBoxS .img:first-child {
  margin-bottom: 4px;
  margin-right: 4px;
}

.kImgBoxS .img:nth-child(2) {
  margin-bottom: 4px;
}

.kImgBoxS .img:nth-child(3) {
  margin-right: 4px;
}

.imgCover {
  width: 45px;
  height: 24px;
  background-size: cover;
  background-repeat: no-repeat;
  display: inline-block;
  margin: 5px 0 0 10px;
  background-position: center center;
}

.el-divider--vertical {
  height: 500px;
}

.box-eltab {
  width: 100%;
}

.top-filter {
  background-color: #fff;
  padding: 16px 16px 0;
}

.ks_content {
  background: #fff;
  width: calc(100% - 32px);
  margin: 0 auto;
  padding: 16px;
  box-sizing: border-box;
}

.ks_toolbar {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.ks_toolbar .title {
  font-size: 16px;
  font-weight: bold;
  display: flex;
}

.ks_toolbar .title span {
  font-size: 14px;
  color: #999;
  font-weight: normal;
  margin-left: 10px;
}

.target-box {
  display: flex;
  justify-content: space-between;
  height: calc(100% - 54px);
}

.target-box-left {
  width: 270px;
  border: 1px solid #ebeef5;
  overflow: auto;
}

.k-page-content /deep/ .target-dialog {
  height: calc(100% - 80px);
}

.k-page-content /deep/ .target-dialog .el-dialog__body {
  height: calc(100% - 110px);
}

.target-box-left ul li {
  display: block;
  line-height: 44px;
  height: 44px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-size: 14px;
  padding: 0 10px;
  box-sizing: border-box;
  border-bottom: 1px solid #ebeef5;
  cursor: pointer;
}

.target-box-left ul li.hov,
.target-box-left ul li:hover {
  color: #007ad6;
  background: #f5f7fa;
}

.target-box-right {
  margin-left: 16px;
  width: calc(100% - 270px);
  display: flex;
  flex-wrap: wrap;
}

.target-box-right-top {
  border: 1px solid #ebeef5;
  background: #f5f7fa;
  padding: 12px;
  box-sizing: border-box;
  height: 54px;
  width: 100%;
}

.target-box-right-bot {
  display: flex;
  width: 100%;
  /* height:calc(100% - 70px);margin-top:16px; */
  height: 100%;
  justify-content: space-between;
}

.target-checked {
  width: 270px;
  border: 1px solid #ebeef5;
  height: 100%;
  margin-left: 16px;
}

.target-checked h3 {
  height: 30px;
  line-height: 30px;
  background: #f5f7fa;
  font-size: 14px;
  font-weight: normal;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 12px;
  border-bottom: 1px solid #ebeef5;
}

.target-checked h3 span:nth-child(1) {
  color: #000;
}

.target-checked h3 span:nth-child(2) {
  color: #007ad6;
  cursor: pointer;
}

.target-checked-con {
  padding: 10px 0;
  box-sizing: border-box;
  height: calc(100% - 31px);
  overflow: auto;
}

.target-checked ul li {
  padding: 0 12px;
  line-height: 25px;
  font-size: 14px;
  position: relative;
}

.target-checked ul li i {
  display: block;
  position: absolute;
  right: 12px;
  top: 0;
  line-height: 25px;
  cursor: pointer;
}

.target-data {
  width: calc(100% - 270px);
  height: calc(100% - 40px);
}

.target-data .el-pagination {
  padding: 5px;
  border: 1px solid #ebeef5;
  border-top: none;
}

.box-card {
  margin-bottom: 30px;
}

.k-page-content /deep/ .target-dialog .el-tabs {
  height: 100%;
}

.k-page-content /deep/ .target-dialog .el-tabs .el-tabs__content {
  height: calc(100% - 55px);
}

.k-page-content /deep/ .target-dialog .el-tabs .el-tabs__content .el-tab-pane {
  height: 100%;
}

.k-page-content
  /deep/
  .target-dialog
  .el-tabs
  .el-tabs__content
  .el-tab-pane
  .target-box {
  height: 100%;
}

.k-page-content /deep/ .target-dialog .el-dialog__body {
  padding: 0 16px;
}

.sourceBox {
  display: flex;
  flex-flow: column;
  height: 100%;
}

.sourceBoxTop {
  height: 30px;
}

.sourceBoxCen {
  height: calc(100% - 40px);
  margin-top: 10px;
  display: flex;
  box-sizing: border-box;
  border-right: 1px solid #ebeef5;
  border-top: 1px solid #ebeef5;
  border-bottom: 1px solid #ebeef5;
}

.sourceBoxCenLeft {
  width: 200px;
  border-left: 1px solid #ebeef5;
  box-sizing: border-box;
}

.sourceBoxCenLeft .target-box-left {
  width: 100%;
  border: none;
}

.sourceBoxCenLeft .target-box-left ul li {
  height: 30px;
  line-height: 30px;
  font-size: 12px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.sourceBoxCenCon {
  width: calc(100% - 540px);
  box-sizing: border-box;
  border-left: 1px solid #ebeef5;
}

.sourceBoxCenRight {
  width: 340px;
  box-sizing: border-box;
  border-left: 1px solid #ebeef5;
}

.sourceHeader {
  padding: 0 6px;
  font-size: 12px;
  height: 34px;
  box-sizing: border-box;
  line-height: 34px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: #f5f7fa;
  border-bottom: 1px solid #ebeef5;
}

.sourceCenter {
  height: calc(100% - 50px);
  position: relative;
  margin-top: 16px;
  box-sizing: border-box;
}

.sourceOption {
  height: calc(100% - 40px);
  overflow: auto;
}

.sourceOptionPage {
  height: 40px;
  box-sizing: border-box;
  line-height: 40px;
  background: #f5f7fa;
  border-top: 1px solid #ebeef5;
  position: absolute;
  bottom: 0;
  width: 100%;
  left: 0;
}

.material-component {
  float: left;
}

.block-mid-lis {
  width: 120px;
  height: 160px;
  margin: 0 0 0 19px;
  position: relative;
  cursor: pointer;
}

.block-mid-lis .mid-lis-img {
  width: 120px;
  height: 120px;
  vertical-align: middle;
  overflow: hidden;
  background: #f9f9f9;
  border: 1px solid hsla(0, 0%, 80%, 0.5);
  position: relative;
}

.block-mid-lis .mid-lis-img .imgBox-Box {
  width: 120px;
  height: 120px;
  vertical-align: middle;
  display: table-cell;
  text-align: center;
}

.adesk__material-use-status {
  position: absolute;
  top: 0;
  right: 0;
  display: block;
  width: 33.33%;
  height: 24px;
  border-bottom-left-radius: 5px;
  font-size: 12px;
  color: #fff;
  text-align: center;
  line-height: 24px;
}

.adesk__material-use-status.status-1 {
  background-color: #f90;
}

.adesk__material-use-status.status-0 {
  background-color: #ed4014;
}

.adesk__material-use-status.status-2 {
  background-color: #657180;
}

.adesk__material-use-status.status-3 {
  background-color: #69f;
}

.block-mid-lis .mid-lis-img .imgBox-Box .imgBox-img {
  position: absolute;
  max-width: 100%;
  max-height: 100%;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
}

.adesk__material-show {
  position: absolute;
  right: 2px;
  bottom: 1px;
}

.mid-lis-title {
  display: -webkit-box;
  text-overflow: ellipsis;
  overflow: hidden;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
}

.sourceSelect {
  height: calc(100% - 32px);
  margin-top: 16px;
  overflow: auto;
}

.material-info {
  height: 60px;
  line-height: 60px;
  display: flex;
  justify-content: space-between;
  padding: 0 10px;
}
.material-info-border{
  border-bottom:1px solid #ebeef5;
}

.material-info .material-info-base {
  display: flex;
  align-items: center;
}

.material-info .material-info-base .image {
  height: 50px;
  width: 40px;
  border: 1px solid #dee4f5;
  display: flex;
  justify-content: center;
  align-items: center;
}

.material-info .material-info-base .image img {
  max-width: 40px;
  max-height: 50px;
}

.material-info .material-info-base .material-name {
  margin: 10px;
  font-size: 12px;
  line-height: 25px;
  height: 80%;
  width: 230px;
}

.material-info .material-info-base .creative-templeate-tag {
  font-size: 11px;
  height: 18px;
  background-color: #3566d9;
  display: inline-block;
  line-height: 18px;
  border-radius: 3px;
  padding: 0 3px;
  color: #fff;
  margin-right: 3px;
  font-weight: 400;
  font-style: normal;
}

.material-info .material-delete {
  font-size: 18px;
  cursor: pointer;
}

.sourceTree {
  padding: 0 6px;
}

.block-mid-lis .mask-cover {
  position: absolute;
  top: 0;
  left: 0;
  width: 122px;
  height: 122px;
  line-height: 122px;
  z-index: 2;
  background-color: rgba(0, 0, 0, 0.7);
  text-align: center;
  padding: 15px 0;
  box-sizing: border-box;
  color: #fff;
}

.block-mid-lis .mask-cover i {
  font-size: 60px;
  font-weight: 700;
}

.adgroup_create_type .el-checkbox.is-bordered.el-checkbox--mini {
  width: 150px;
  height: 80px;
  position: relative;
}

.adgroup_create_type
  .el-checkbox.is-bordered.el-checkbox--mini
  .el-checkbox__label {
  position: absolute;
  left: 40px;
  top: 30px;
  width: 50px;
  text-align: center;
}

.kPlcreat .box-card {
  margin-bottom: 15px;
}

.coverTip {
  color: #999;
  line-height: 30px;
}

.kCover {
  display: flex;
  flex-direction: column;
  height: 100%;
}

.coverTop {
  height: 85px;
  box-sizing: border-box;
  padding-top: 15px;
}

.coverBox {
  flex: 1;
  border: 1px solid #ebeef5;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.coverBoxTitle {
  font-size: 12px;
  height: 34px;
  line-height: 34px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: #f5f7fa;
  border-bottom: 1px solid #ebeef5;
}

.coverBoxTitle .left {
  width: 280px;
  box-sizing: border-box;
  border-right: 1px solid #ebeef5;
  padding: 0 8px;
}

.coverBoxTitle .right {
  align-items: center;
  flex: 1;
  display: flex;
  justify-content: space-between;
  box-sizing: border-box;
  padding: 0 8px;
}

.coverBoxCon {
  flex: 1;
  overflow-y: auto;
}

.coverList {
  border-bottom: 1px solid #ebeef5;
  display: flex;
  justify-content: space-between;
  flex-direction: row;
  height: 340px;
  align-items: center;
}

.coverList .left {
  width: 280px;
  box-sizing: border-box;
  padding: 10px 10px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.coverList .right {
  flex: 1;
  padding: 0 10px;
  display: flex;
  flex-wrap: wrap;
}

.coverList .right div {
  width: 145px;
  height: 145px;
  background: #eaeef4;
  position: relative;
  margin: 5px 20px 5px 0;
  display: flex;
  align-items: center;
  justify-content: center;
}

.coverList .right div img {
  max-width: 145px;
  max-height: 145px;
}

.coverList .right div .el-checkbox {
  position: absolute;
  left: 5px;
  top: 5px;
}

.previewDialog .el-drawer__body {
  overflow-y: scroll;
  padding: 10px 15px;
}

.previewTitle {
  padding-bottom: 15px;
}

.previewTitle span {
  position: relative;
  padding-left: 20px;
  display: inline-block;
  margin-right: 15px;
  font-weight: bold;
  font-size: 14px;
}

.previewTitle span:before {
  content: '';
  display: block;
  position: absolute;
  left: 0;
  top: 50%;
  margin-top: -2px;
  width: 8px;
  height: 4px;
  background-color: #507ae9;
}

.previewTitle span:nth-child(2):before {
  background-color: #f1b142;
}

.previewTitle span:nth-child(3):before {
  background-color: #8bc65e;
}

.sourceCover {
  display: flex;
  justify-content: center;
  position: relative;
}

.sourceCover img {
  width: 50px;
}

.sourceCover span {
  position: absolute;
  bottom: 5px;
  right: 10px;
  color: #4f79e8;
}

.leftMain {
  height: 476px;
  overflow: hidden;
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
}

.leftBox {
  width: calc(33% - 10px);
  margin-right: 10px;
  margin-bottom: 10px;
  position: relative;
}

.leftBox:nth-child(3n) {
  margin-right: 0;
}

.leftBox .close {
  position: absolute;
  right: -5px;
  top: -5px;
}

.leftBox .close .el-icon-error {
  font-size: 24px;
}

.leftBox .coverImg {
  width: 100%;
  height: 150px;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
}

.leftBox .coverImg .image {
  max-width: 100%;
  max-height: 150px;
}

.leftBox .tips {
  padding: 5px 10px;
}

.leftBox .tips .title {
  height: 40px;
  line-height: 40px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  -o-text-overflow: ellipsis;
}

.leftBox .tips .btn {
  display: flex;
  justify-content: flex-end;
  padding-bottom: 6px;
  align-items: center;
}

.leftBox .tips .btn .el-switch {
  margin-left: 5px;
}
</style>
